// src/components/one-key-onboarding/one-key-onboarding-wrapper.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment EGDSButtonFragment on EGDSButton {\n    primary\n    accessibility\n    disabled\n    analytics {\n      linkName\n      referrerId\n    }\n    icon {\n      description\n      id\n      title\n      token\n      theme\n    }\n    action {\n      ...ButtonLinkActionFragment\n    }\n  }\n\n  fragment ButtonLinkActionFragment on UILinkAction {\n    resource {\n      ...HttpURIFragment\n    }\n    target\n    useRelativePath\n  }\n\n  fragment HttpURIFragment on HttpURI {\n    relativePath\n    value\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment EGDSIllustrationFragment on Illustration {\n    description\n    id\n    link: url\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment EGDSMarkFragment on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        __typename\n        relativePath\n        value\n      }\n    }\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...EGDSIconFragment\n    }\n\n    ... on Mark {\n      ...EGDSMarkFragment\n    }\n\n    ... on Illustration {\n      ...EGDSIllustrationFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment EGDSImageFragment on Image {\n    description\n    url\n    aspectRatio\n  }\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n        ... on HttpURI {\n          relativePath\n        }\n      }\n      target\n      useRelativePath\n    }\n    disabled\n    standardLinkIcon: icon {\n      ...EGDSIconFragment\n    }\n    iconPosition\n    size\n    text\n  }\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment OnboardingButtonActionFragment on OneKeyOnboardingButtonAction {\n    ...OnboardingButtonDismissActionFragment\n    ...OnboardingButtonUILinkActionFragment\n    ...OnboardingButtonOperationActionFragment\n  }\n\n  fragment OnboardingButtonDismissActionFragment on EGDSDismissAction {\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    label\n  }\n\n  fragment OnboardingButtonUILinkActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    resource {\n      value\n      ...ButtonHttpURIFragment\n    }\n    target\n    useRelativePath\n  }\n\n  fragment ButtonHttpURIFragment on HttpURI {\n    relativePath\n  }\n\n  fragment OnboardingButtonOperationActionFragment on OnboardingOperationAction {\n    actionType\n  }\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment EGDSMarkCardFragment on EGDSMarkCard {\n    description\n    id\n    mark {\n      ...EGDSMarkFragment\n    }\n    subTitle\n    title\n  }\n  ", "\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment EGDSCardFragment on EGDSCard {\n    ... on EGDSMarkCard {\n      ...EGDSMarkCardFragment\n    }\n  }\n  ", "\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment ContextualOnboardingFragment on OneKeyContextualOnboarding {\n    brandLogos {\n      ...EGDSGraphicFragment\n    }\n    headerBrandLogo {\n      ...EGDSGraphicFragment\n    }\n    link {\n      icon {\n        ...EGDSIconFragment\n      }\n      ...EGDSStandardLinkFragment\n    }\n    oneKeyCard {\n      ...EGDSCardFragment\n    }\n    primaryButton {\n      button {\n        ...EGDSButtonFragment\n      }\n      action {\n        ...OnboardingButtonActionFragment\n      }\n    }\n    subText\n    title\n    titleImage {\n      ...EGDSGraphicFragment\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment InterstitialLoadingFragment on OneKeyOnboardingInterstitialLoading {\n    headerBrandLogo {\n      ...EGDSGraphicFragment\n    }\n    titleMessage\n    waitingMessage\n    welcomeMessage\n    timeoutMessage\n    brandLogos {\n      ...EGDSGraphicFragment\n    }\n    headerBrandLogo {\n      ...EGDSGraphicFragment\n    }\n    titleImage {\n      ...EGDSGraphicFragment\n    }\n    onLoadOperation {\n      actionType\n    }\n    primaryButton {\n      button {\n        ...EGDSButtonFragment\n      }\n      action {\n        ...OnboardingButtonActionFragment\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  mutation OnboardingOperation(\n    $context: ContextInput!\n    $onboardingOperation: String!\n    $additionalContext: AdditionalOnboardingOperationContextInput\n  ) {\n    oneKeyOnboardingOperation(context: $context, onboardingOperation: $onboardingOperation, additionalContext: $additionalContext) {\n      operationStatus\n      operationResult {\n        ...OnboardingButtonUILinkActionFragment\n        ...OnboardingButtonDismissActionFragment\n        ...ContextualOnboardingFragment\n        ...InterstitialLoadingFragment\n      }\n    }\n  }\n\n  fragment OnboardingButtonDismissActionFragment on EGDSDismissAction {\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    label\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment GettingStartedFragment on OneKeyOnboardingGettingStarted {\n    headerImage {\n      ...EGDSImageFragment\n    }\n    title\n    subTitles\n    images {\n      ...EGDSGraphicFragment\n    }\n    gettingStartedlink: link {\n      icon {\n        ...EGDSIconFragment\n      }\n      ...EGDSStandardLinkFragment\n    }\n    consentText\n    primaryButton {\n      ...GettingStartedPrimaryButtonFragment\n    }\n  }\n\n  fragment GettingStartedPrimaryButtonFragment on OneKeyOnboardingButton {\n    button {\n      ...EGDSButtonFragment\n    }\n    action {\n      ...OnboardingButtonActionFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment TermsAndConditionsFragment on OneKeyOnboardingTermsAndConditions {\n    headerBrandLogo {\n      ...EGDSGraphicFragment\n    }\n    additionalText\n    dismissButton {\n      ...EGDSButtonFragment\n    }\n    images {\n      ...EGDSGraphicFragment\n    }\n    links {\n      ...EGDSStandardLinkFragment\n    }\n    primaryButton {\n      ...TermsPrimaryButtonFragment\n    }\n    secondaryButton {\n      ...EGDSButtonFragment\n    }\n    onDismissOperation {\n      actionType\n    }\n    subText\n    title\n  }\n\n  fragment TermsPrimaryButtonFragment on OneKeyOnboardingButton {\n    button {\n      ...EGDSButtonFragment\n    }\n    action {\n      ...OnboardingButtonActionFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment AccountMergeFragment on OneKeyOnboardingAccountMerge {\n    headerBrandLogo {\n      ...EGDSGraphicFragment\n    }\n    images {\n      ...EGDSGraphicFragment\n    }\n    accountMergelink: link {\n      ...EGDSStandardLinkFragment\n    }\n    primaryButton {\n      button {\n        ...EGDSButtonFragment\n      }\n      action {\n        ...OnboardingButtonActionFragment\n      }\n    }\n    subTitles\n    title\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  mutation OneKeyUniversalOnboardingMutation($context: ContextInput!, $onboardingOperation: String!) {\n    oneKeyUniversalOnboardingOperation(context: $context, onboardingOperation: $onboardingOperation) {\n      operationStatus\n    }\n  }\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  fragment BrandAssetsFragment on OneKeyUniversalOnboardingBrandAssetCollection {\n    titleImage {\n      ...EGDSGraphicFragment\n    }\n    brandLogos {\n      ...EGDSGraphicFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment OnboardingButtonFragment on OneKeyUniversalOnboardingButton {\n    button {\n      ...EGDSButtonFragment\n    }\n    action {\n      ...OneKeyUniversalOnboardingButtonActionFragment\n    }\n    secondaryAction {\n      ...OneKeyUniversalOnboardingButtonActionFragment\n    }\n  }\n\n  fragment OneKeyUniversalOnboardingButtonActionFragment on OneKeyUniversalOnboardingButtonAction {\n    ...OneKeyUniversalOnboardingButtonDismissActionFragment\n    ...OneKeyUniversalOnboardingButtonUILinkActionFragment\n    ...OneKeyUniversalOnboardingOperationActionFragment\n  }\n\n  fragment OneKeyUniversalOnboardingButtonDismissActionFragment on EGDSDismissAction {\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    label\n  }\n\n  fragment OneKeyUniversalOnboardingButtonUILinkActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    resource {\n      value\n      ...ButtonHttpURIFragment\n    }\n    target\n    useRelativePath\n  }\n\n  fragment OneKeyUniversalOnboardingOperationActionFragment on OneKeyUniversalOnboardingOperationAction {\n    actionType\n  }\n\n  fragment ButtonHttpURIFragment on HttpURI {\n    relativePath\n  }\n\n  ", "\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  fragment OnboardingLinkFragment on OneKeyUniversalOnboardingLink {\n    link {\n      ...EGDSStandardLinkFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  fragment HeroImageFragment on Image {\n    description\n    url\n  }\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  fragment WelcomeScreenFragment on OneKeyUniversalOnboardingWelcomeScreen {\n    heroImage {\n      ...HeroImageFragment\n    }\n    brandAssets {\n      ...BrandAssetsFragment\n    }\n    title\n    subTitles\n    learnMoreLink {\n      ...OnboardingLinkFragment\n    }\n    primaryButton {\n      ...OnboardingButtonFragment\n    }\n    consentText\n    termsAndConditionsLink {\n      ...OnboardingLinkFragment\n    }\n    privacyLink {\n      ...OnboardingLinkFragment\n    }\n    dismissButton {\n      ...OnboardingButtonFragment\n    }\n    onLoadOperation {\n      actionType\n    }\n    ariaLabel\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject22() {
  var data = _tagged_template_literal(["\n  fragment EGDSLoyaltyBadgeFragment on EGDSLoyaltyBadge {\n    accessibility\n    badgeText: text\n    size\n    badgeTheme: theme\n  }\n"]);
  _templateObject22 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject23() {
  var data = _tagged_template_literal(["\n  fragment BalanceSectionFragment on OneKeyUniversalContextualOnboardingBalance {\n    title\n    balance\n    subTitles\n  }\n"]);
  _templateObject23 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject24() {
  var data = _tagged_template_literal(["\n  fragment BenefitFragment on OneKeyUniversalContextualOnboardingBenefit {\n    icon {\n      ...EGDSIconFragment\n    }\n    description\n  }\n\n  ", "\n"]);
  _templateObject24 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject25() {
  var data = _tagged_template_literal(["\n  fragment InfoDialogFragment on OneKeyUniversalOnboardingInfoDialog {\n    heading\n    description\n    primaryButton {\n      ...OnboardingButtonFragment\n    }\n    ariaLabel\n  }\n\n  ", "\n"]);
  _templateObject25 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject26() {
  var data = _tagged_template_literal(["\n  fragment InfoSectionFragment on OneKeyUniversalOnboardingInfoSection {\n    infoButton {\n      ...OnboardingButtonFragment\n    }\n    dialog {\n      ...InfoDialogFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject26 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject27() {
  var data = _tagged_template_literal(["\n  fragment ContextualScreenFragment on OneKeyUniversalOnboardingContextualScreen {\n    brandAssets {\n      ...BrandAssetsFragment\n    }\n    oneKeyCashInfoSection {\n      ...InfoSectionFragment\n    }\n    tierBadge {\n      ...EGDSLoyaltyBadgeFragment\n    }\n    title\n    benefits {\n      ...BenefitFragment\n    }\n    balanceSection {\n      ...BalanceSectionFragment\n    }\n    primaryButton {\n      ...OnboardingButtonFragment\n    }\n    primaryLink {\n      ...OnboardingLinkFragment\n    }\n    ariaLabel\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject27 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject28() {
  var data = _tagged_template_literal(["\n  query OneKeyOnboardingQuery($context: ContextInput!, $additionalContext: AdditionalOnboardingContextInput) {\n    oneKeyOnboarding(context: $context, additionalContext: $additionalContext) {\n      ...OneKeyOnboardingSheetFragment\n    }\n  }\n\n  fragment OneKeyOnboardingSheetFragment on OneKeyOnboardingSheet {\n    element {\n      ...OneKeyOnboardingResultFragment\n    }\n  }\n\n  fragment OneKeyOnboardingResultFragment on OneKeyOnboardingResult {\n    ...GettingStartedFragment\n    ...TermsAndConditionsFragment\n    ...InterstitialLoadingFragment\n    ...AccountMergeFragment\n    ...ContextualOnboardingFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject28 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject29() {
  var data = _tagged_template_literal(["\n  query OneKeyUniversalOnboardingQuery($context: ContextInput!, $originUrl: String) {\n    oneKeyUniversalOnboarding(context: $context, originUrl: $originUrl) {\n      ...OneKeyUniversalOnboardingScreenFragment\n    }\n  }\n\n  fragment OneKeyUniversalOnboardingScreenFragment on OneKeyUniversalOnboardingScreen {\n    screen {\n      ...OneKeyUniversalOnboardingScreenResultFragment\n    }\n  }\n\n  fragment OneKeyUniversalOnboardingScreenResultFragment on OneKeyUniversalOnboardingScreenResult {\n    ...WelcomeScreenFragment\n    ...ContextualScreenFragment\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject29 = function _templateObject() {
    return data;
  };
  return data;
}
import React44, { useEffect as useEffect11 } from "react";
import { useExperiment } from "@shared-ui/experiment-context";
import { useLoggerEvents as useLoggerEvents12 } from "@shared-ui/logger-context";
// src/utils/logger/logger-events.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var LOGGER_EVENTS = {
  ONE_KEY_ONBOARDING_TNL_EXPOSURE: new SystemEvent(SystemEventLevel.INFO, "ONE_KEY_ONBOARDING_TNL_EXPOSURE"),
  ONE_KEY_ONBOARDING_QUERY_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_ONBOARDING_QUERY_ERROR"),
  ONE_KEY_ONBOARDING_GENERIC_MUTATION_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_ONBOARDING_GENERIC_MUTATION_ERROR"),
  ONE_KEY_ONBOARDING_TERMS_AND_CONDITIONS_ACCEPT_MUTATION_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_ONBOARDING_TERMS_AND_CONDITIONS_ACCEPT_MUTATION_ERROR"),
  ONE_KEY_ONBOARDING_TERMS_AND_CONDITIONS_DECLINE_MUTATION_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_ONBOARDING_TERMS_AND_CONDITIONS_DECLINE_MUTATION_ERROR"),
  ONE_KEY_ONBOARDING_TERMS_AND_CONDITIONS_DISMISS_MUTATION_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_ONBOARDING_TERMS_AND_CONDITIONS_DISMISS_MUTATION_ERROR"),
  ONE_KEY_ONBOARDING_ACCOUNT_MERGE_MUTATION_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_ONBOARDING_ACCOUNT_MERGE_MUTATION_ERROR"),
  ONE_KEY_ONBOARDING_INTERSTITIAL_LOADING_MUTATION_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_ONBOARDING_INTERSTITIAL_LOADING_MUTATION_ERROR"),
  ONE_KEY_ONBOARDING_INTERSTITIAL_LOADING_TIMEOUT_ACTION_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_ONBOARDING_INTERSTITIAL_LOADING_TIMEOUT_ACTION_ERROR"),
  ONE_KEY_ONBOARDING_CONTEXTUAL_ONBOARDING_MUTATION_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_ONBOARDING_CONTEXTUAL_ONBOARDING_MUTATION_ERROR"),
  ONE_KEY_ONBOARDING_HEADER_DISMISS_MUTATION_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_ONBOARDING_HEADER_DISMISS_MUTATION_ERROR")
};
var UNIVERSAL_ONBOARDING_LOGGER_EVENTS = {
  ONE_KEY_UNIVERSAL_ONBOARDING_QUERY_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_UNIVERSAL_ONBOARDING_QUERY_ERROR"),
  ONE_KEY_UNIVERSAL_ONBOARDING_WELCOME_SCREEN_MUTATION_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_UNIVERSAL_ONBOARDING_WELCOME_SCREEN_MUTATION_ERROR"),
  ONE_KEY_UNIVERSAL_ONBOARDING_WELCOME_SCREEN_MUTATION_FAILURE: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_UNIVERSAL_ONBOARDING_WELCOME_SCREEN_MUTATION_FAILURE"),
  ONE_KEY_UNIVERSAL_ONBOARDING_WELCOME_SCREEN_MUTATION_SUCCESS: new SystemEvent(SystemEventLevel.INFO, "ONE_KEY_UNIVERSAL_ONBOARDING_WELCOME_SCREEN_MUTATION_SUCCESS"),
  ONE_KEY_UNIVERSAL_ONBOARDING_CONTEXTUAL_SCREEN_MUTATION_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_UNIVERSAL_ONBOARDING_CONTEXTUAL_SCREEN_MUTATION_ERROR"),
  ONE_KEY_UNIVERSAL_ONBOARDING_CONTEXTUAL_SCREEN_MUTATION_FAILURE: new SystemEvent(SystemEventLevel.ERROR, "ONE_KEY_UNIVERSAL_ONBOARDING_CONTEXTUAL_SCREEN_MUTATION_FAILURE"),
  ONE_KEY_UNIVERSAL_ONBOARDING_CONTEXTUAL_SCREEN_MUTATION_SUCCESS: new SystemEvent(SystemEventLevel.INFO, "ONE_KEY_UNIVERSAL_ONBOARDING_CONTEXTUAL_SCREEN_MUTATION_SUCCESS")
};
// src/utils/logger/utils.ts
var stringifyEventPayload = function (payload) {
  return JSON.stringify(payload);
};
// src/utils/utils.ts
var HOMEPAGE_PATH = "/";
var getPath = function (uiLinkAction) {
  var resource = uiLinkAction.resource,
    useRelativePath = uiLinkAction.useRelativePath;
  switch (resource.__typename) {
    case "HttpURI":
      return useRelativePath ? resource.relativePath : resource.value;
    default:
      return resource.value;
  }
};
var getOnboardingActionType = function (onboardingAction) {
  if ((onboardingAction === null || onboardingAction === void 0 ? void 0 : onboardingAction.__typename) === "OnboardingOperationAction") {
    return onboardingAction.actionType;
  }
  return "";
};
var getUniversalOnboardingActionType = function (onboardingButtonAction) {
  if ((onboardingButtonAction === null || onboardingButtonAction === void 0 ? void 0 : onboardingButtonAction.__typename) === "OneKeyUniversalOnboardingOperationAction") {
    return onboardingButtonAction.actionType;
  }
  return "";
};
var navigateToErrorPage = function () {
  window.location.href = "/onboarding/error?origin=".concat(encodeURIComponent(window.location.href));
};
var navigateToLink = function (operationResult) {
  window.location.href = "".concat(getPath(operationResult));
};
var encodeUrl = function (url) {
  var _url_split = _sliced_to_array(url.split("?"), 2),
    path = _url_split[0],
    queryString = _url_split[1];
  var encodedPath = encodeURIComponent(path);
  var encodedQueryString = "";
  if (queryString) {
    encodedQueryString = queryString.split("&").map(function (param) {
      var _param_split = _sliced_to_array(param.split("="), 2),
        key = _param_split[0],
        value = _param_split[1];
      return "".concat(key, "=").concat(encodeURIComponent(value));
    }).join("&");
  }
  var encodedPathWithQueryParam = encodedQueryString ? "".concat(encodedPath, "?").concat(encodedQueryString) : encodedPath;
  var replaceDecodedSlash = encodedPathWithQueryParam.replace(/%2F/g, "/");
  return replaceDecodedSlash;
};
var encodeAbsoluteUrl = function (url) {
  var relativePathWithQueryParams = url.pathname + url.search;
  return encodeUrl(relativePathWithQueryParams);
};
var isRelativePath = function (path) {
  return /^\/[^/].*/.test(path);
};
var toRelativeURL = function (input) {
  try {
    var url = new URL(input);
    return encodeAbsoluteUrl(url);
  } catch (error) {
    if (isRelativePath(input)) {
      return encodeUrl(input);
    }
    return "/";
  }
};
var navigateToRelativeUrlOrFallbackUrl = function (url) {
  var redirectUrl = url ? toRelativeURL(url) : HOMEPAGE_PATH;
  window.location.assign(redirectUrl);
};
// src/components/one-key-onboarding/one-key-onboarding.tsx
import React42, { useEffect as useEffect9, useState as useState6 } from "react";
import { gql as gql29, useQuery } from "@apollo/client";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { useLoggerEvents as useLoggerEvents10 } from "@shared-ui/logger-context";
import { UitkSheetTransition } from "uitk-react-sheet";
// src/components/one-key-onboarding/onboarding-screen.tsx
import React41 from "react";
// src/components/one-key-onboarding/onboarding-sheets/getting-started.tsx
import React21 from "react";
import { gql as gql14 } from "@apollo/client";
// ../internal/src/components/egds-button/egds-button.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSOverlayButton, EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSIcon } from "@egds/react-core/icons";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/hooks/use-gss-redirect-url.tsx
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useBexApi } from "@shared-ui/bex-api-context";
var HOTWIRE = 30031;
var useGssRedirectUrl = function (baseUrl) {
  var getReturnUrlParam = function getReturnUrlParam(location2, siteId2) {
    var pathname = location2.pathname,
      search = location2.search,
      hash = location2.hash;
    var returnUrl = pathname.concat(search, hash);
    switch (siteId2) {
      case HOTWIRE:
        return "&redirectUrl=targeturl=".concat(encodeURIComponent(returnUrl), "&referrerId=wl_prod");
      default:
        return "&uurl=".concat(encodeURIComponent("e3id=redr&rurl=".concat(returnUrl)));
    }
  };
  var hasRedirectUrl = baseUrl.indexOf("uurl") > -1;
  var currentLocation = useLocation();
  var getCurrentLocation = function () {
    return {
      pathname: "".concat(currentLocation.pathname),
      search: "".concat(currentLocation.search),
      hash: "".concat(currentLocation.hash)
    };
  };
  var context = useBexApi().context;
  var _useState = _sliced_to_array(useState(getCurrentLocation), 2),
    location = _useState[0],
    setLocation = _useState[1];
  var siteId = context === null || context === void 0 ? void 0 : context.siteId;
  useEffect(function () {
    var handleLocationChange = function () {
      return setLocation(getCurrentLocation());
    };
    window.addEventListener("popstate", handleLocationChange);
    return function () {
      return window.removeEventListener("popstate", handleLocationChange);
    };
  }, [getCurrentLocation]);
  var authURL = "";
  if (!hasRedirectUrl) {
    authURL = baseUrl + (baseUrl.indexOf("?") !== -1 ? "" : "?") + getReturnUrlParam(location || {}, siteId);
  }
  return authURL;
};
var _obj;
// ../internal/src/components/uitk-link-target-mapper.tsx
var UILinkTargetMap = (_obj = {}, _define_property(_obj, "EXTERNAL" /* EXTERNAL */, "_blank"), _define_property(_obj, "INTERNAL" /* INTERNAL */, "_self"), _obj);
// ../internal/src/components/egds-button/button-action-helpers.ts
var getLoyaltyUILinkActionPath = function (action) {
  if (action.resource.__typename !== "HttpURI") {
    return null;
  }
  return action.useRelativePath ? action.resource.relativePath : action.resource.value;
};
var getLoyaltyUILinkActionTarget = function (action) {
  return UILinkTargetMap[action.target];
};
// ../internal/src/components/egds-button/egds-button.tsx
var _Fragment = gql(_templateObject());
var deriveLinkProps = function (action) {
  if ((action === null || action === void 0 ? void 0 : action.__typename) !== "UILinkAction") {
    return {};
  }
  var path = getLoyaltyUILinkActionPath(action);
  if (!path) {
    return {};
  }
  return {
    href: path,
    target: getLoyaltyUILinkActionTarget(action),
    tag: "a"
  };
};
var EGDSButton = function (param) {
  var className = param.className,
    dataStid = param.dataStid,
    domRef = param.domRef,
    href = param.href,
    isFullWidth = param.isFullWidth,
    onClickHandler = param.onClickHandler,
    size = param.size,
    inverse = param.inverse,
    isDisabled = param.isDisabled,
    isNoTextAllowed = param.isNoTextAllowed,
    _param_data = param.data,
    __typename = _param_data.__typename,
    accessibility = _param_data.accessibility,
    primary = _param_data.primary,
    disabled = _param_data.disabled,
    analytics = _param_data.analytics,
    action = _param_data.action,
    icon = _param_data.icon;
  var clickTracker = useClickTracker();
  var linkProps = deriveLinkProps(action);
  var _linkProps_href;
  var urlWithRedirect = useGssRedirectUrl((_linkProps_href = linkProps.href) !== null && _linkProps_href !== void 0 ? _linkProps_href : "");
  var handleOnClick = React.useCallback(function () {
    onClickHandler === null || onClickHandler === void 0 ? void 0 : onClickHandler();
    if (analytics) {
      clickTracker(analytics.referrerId, analytics.linkName);
    }
  }, [onClickHandler, clickTracker, analytics]);
  if (!primary && !isNoTextAllowed) {
    return null;
  }
  if ((linkProps === null || linkProps === void 0 ? void 0 : linkProps.href) && urlWithRedirect) {
    linkProps.href = urlWithRedirect;
  }
  var buttonProps = _object_spread({
    "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
    className: className,
    disabled: isDisabled || disabled,
    href: href,
    isFullWidth: isFullWidth,
    onClick: handleOnClick,
    size: size,
    domRef: domRef
  }, linkProps);
  switch (__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React.createElement(EGDSPrimaryButton, _object_spread_props(_object_spread({}, buttonProps), {
        "data-stid": dataStid,
        inverse: inverse
      }), primary);
    case "UISecondaryButton":
      return /* @__PURE__ */React.createElement(EGDSSecondaryButton, _object_spread_props(_object_spread({}, buttonProps), {
        "data-stid": dataStid,
        inverse: inverse
      }), primary);
    case "UITertiaryButton":
      var _icon_title, _icon_theme;
      return /* @__PURE__ */React.createElement(EGDSTertiaryButton, _object_spread_props(_object_spread({}, buttonProps), {
        "data-stid": dataStid,
        inverse: inverse
      }), icon && /* @__PURE__ */React.createElement(EGDSIcon, {
        description: icon.description,
        id: icon.id,
        name: icon.token,
        title: (_icon_title = icon.title) !== null && _icon_title !== void 0 ? _icon_title : void 0,
        theme: (_icon_theme = icon.theme) !== null && _icon_theme !== void 0 ? _icon_theme : void 0
      }), primary);
    case "EGDSOverlayButton":
      var _icon_title1, _icon_theme1;
      return /* @__PURE__ */React.createElement(EGDSOverlayButton, _object_spread_props(_object_spread({}, buttonProps), {
        "data-stid": dataStid
      }), icon && /* @__PURE__ */React.createElement(EGDSIcon, {
        description: icon.description,
        id: icon.id,
        name: icon.token,
        title: (_icon_title1 = icon.title) !== null && _icon_title1 !== void 0 ? _icon_title1 : void 0,
        theme: (_icon_theme1 = icon.theme) !== null && _icon_theme1 !== void 0 ? _icon_theme1 : void 0
      }), primary);
    default:
      return null;
  }
};
EGDSButton.fragment = _Fragment;
EGDSButton.displayName = "EGDSButton";
// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
// ../internal/src/components/egds-graphic/egds-icon.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var __EGDSIconFragment = gql2(_templateObject1());
var EGDSIcon2 = function (param) {
  var className = param.className,
    theme = param.theme,
    data = param.data;
  var spotlight = (data === null || data === void 0 ? void 0 : data.withBackground) ? "info" : void 0;
  var _data_title;
  return /* @__PURE__ */React2.createElement(UitkIcon, {
    className: className,
    description: data === null || data === void 0 ? void 0 : data.description,
    id: data === null || data === void 0 ? void 0 : data.id,
    name: data !== null ? data.id : "",
    size: (data === null || data === void 0 ? void 0 : data.size) ? UitkIconSize[data.size] : void 0,
    title: (_data_title = data === null || data === void 0 ? void 0 : data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
    theme: theme || (data === null || data === void 0 ? void 0 : data.theme) || void 0,
    spotlight: spotlight
  });
};
EGDSIcon2.displayName = "EGDSIcon";
EGDSIcon2.fragment = __EGDSIconFragment;
// ../internal/src/components/egds-graphic/egds-illustration.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkIllustrations } from "uitk-react-illustrations";
var __EGDSIllustrationFragment = gql3(_templateObject2());
var EGDSIllustration = function (param) {
  var data = param.data;
  return /* @__PURE__ */React3.createElement(UitkIllustrations, {
    alt: data.description,
    url: data.link
  });
};
EGDSIllustration.displayName = "Illustration";
EGDSIllustration.fragment = __EGDSIllustrationFragment;
// ../internal/src/components/egds-graphic/egds-mark.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
var __EGDSMarkFragment = gql4(_templateObject3());
var EGDSMark = function (param) {
  var className = param.className,
    markSize = param.markSize,
    data = param.data;
  var _data_url;
  return /* @__PURE__ */React4.createElement(UitkMark, {
    className: className,
    description: data.description,
    id: data.id,
    name: data.id,
    size: markSize || data.markSize && UitkMarkSize[data.markSize],
    url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
  });
};
EGDSMark.displayName = "EGDSMark";
EGDSMark.fragment = __EGDSMarkFragment;
// ../internal/src/components/egds-graphic/egds-graphic.tsx
var __EGDSGraphicFragment = gql5(_templateObject4(), EGDSIcon2.fragment, EGDSMark.fragment, EGDSIllustration.fragment);
var EGDSGraphic = function (param) {
  var className = param.className,
    markSize = param.markSize,
    data = param.data;
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React5.createElement(EGDSIcon2, {
        className: className,
        data: data
      });
    case "Mark":
      return /* @__PURE__ */React5.createElement(EGDSMark, {
        className: className,
        data: data,
        markSize: markSize
      });
    case "Illustration":
      return /* @__PURE__ */React5.createElement(EGDSIllustration, {
        data: data
      });
    default:
      return null;
  }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;
// ../internal/src/components/egds-image/egds-image.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkFigure, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage } from "uitk-react-images";
// ../internal/src/utils/aspect-ratio-mapper.ts
import { UitkFigureAspectRatioType } from "uitk-react-images";
var _obj1;
var aspectRatioMapper = (_obj1 = {}, _define_property(_obj1, "ONE_ONE" /* ONE_ONE */, UitkFigureAspectRatioType.R1_1), _define_property(_obj1, "FOUR_THREE" /* FOUR_THREE */, UitkFigureAspectRatioType.R4_3), _define_property(_obj1, "SIXTEEN_NINE" /* SIXTEEN_NINE */, UitkFigureAspectRatioType.R16_9), _define_property(_obj1, "THREE_TWO" /* THREE_TWO */, UitkFigureAspectRatioType.R3_2), _define_property(_obj1, "THREE_FOUR" /* THREE_FOUR */, UitkFigureAspectRatioType.R3_4), _define_property(_obj1, "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */, UitkFigureAspectRatioType.R21_9), _define_property(_obj1, "FOUR_ONE" /* FOUR_ONE */, UitkFigureAspectRatioType.R4_1), _obj1);
// ../internal/src/components/egds-image/egds-image.tsx
var fragment = gql6(_templateObject5());
var EGDSImage = function (param) {
  var _param_data = param.data,
    description = _param_data.description,
    url = _param_data.url,
    aspectRatio = _param_data.aspectRatio,
    className = param.className,
    lazyLoading = param.lazyLoading,
    placeholderImage = param.placeholderImage,
    roundcorner = param.roundcorner,
    ratio = param.ratio;
  var imageAspectRatio = ratio || (aspectRatio ? aspectRatioMapper[aspectRatio] : UitkFigureAspectRatioType2.R1_1);
  return /* @__PURE__ */React6.createElement(UitkFigure, {
    className: className,
    ratio: imageAspectRatio,
    roundcorner: roundcorner
  }, /* @__PURE__ */React6.createElement(UitkImage, {
    alt: description,
    src: url,
    lazyLoading: lazyLoading,
    placeholderImage: placeholderImage
  }));
};
EGDSImage.fragment = fragment;
EGDSImage.displayName = "EGDSImage";
// ../internal/src/components/egds-text/egds-standard-link.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
import { UitkText } from "uitk-react-text";
var _obj2;
// ../internal/src/components/egds-text/__private/link-map.ts
var linkSizeMapper = (_obj2 = {}, _define_property(_obj2, "SMALL" /* SMALL */, "small"), _define_property(_obj2, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj2, "LARGE" /* LARGE */, "large"), _obj2);
var _obj3;
var UILinkTargetMap2 = (_obj3 = {}, _define_property(_obj3, "EXTERNAL" /* EXTERNAL */, "_blank"), _define_property(_obj3, "INTERNAL" /* INTERNAL */, "_self"), _obj3);
// ../internal/src/components/egds-text/egds-standard-link.tsx
var fragment2 = gql7(_templateObject6(), EGDSIcon2.fragment);
var getHrefFromLinkAction = function (action) {
  switch (action.resource.__typename) {
    case "HttpURI":
      return action.useRelativePath ? action.resource.relativePath : action.resource.value;
    default:
      return action.resource.value;
  }
};
var IconPlacement = function (param) {
  var icon = param.icon,
    iconPosition = param.iconPosition,
    iconPositionToMatch = param.iconPositionToMatch;
  if (icon && iconPosition === iconPositionToMatch) {
    return /* @__PURE__ */React7.createElement(EGDSIcon2, {
      data: icon
    });
  }
  return null;
};
var EGDSStandardLink = function (param) {
  var className = param.className,
    dataStid = param.dataStid,
    inline = param.inline,
    theme = param.theme,
    align = param.align,
    data = param.data,
    onClickHandler = param.onClickHandler;
  var _data_action = data.action,
    analytics = _data_action.analytics,
    resource = _data_action.resource,
    target = _data_action.target,
    accessibility = _data_action.accessibility,
    useRelativePath = _data_action.useRelativePath,
    disabled = data.disabled,
    iconPosition = data.iconPosition,
    standardLinkIcon = data.standardLinkIcon,
    size = data.size,
    text = data.text;
  var clickTracker = useClickTracker2();
  var onClick = React7.useCallback(function () {
    clickTracker(analytics.referrerId, analytics.linkName);
    if (onClickHandler) {
      onClickHandler();
    }
  }, [clickTracker, analytics]);
  var getPath2 = React7.useCallback(function () {
    return getHrefFromLinkAction(data.action);
  }, [data.action]);
  return /* @__PURE__ */React7.createElement(UitkLink, {
    className: className,
    "data-stid": dataStid,
    size: linkSizeMapper[size],
    onClickCapture: onClick,
    inline: inline,
    disabled: disabled,
    theme: theme || "default",
    align: align
  }, /* @__PURE__ */React7.createElement("a", {
    target: UILinkTargetMap2[target],
    href: getPath2()
  }, /* @__PURE__ */React7.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition: iconPosition,
    iconPositionToMatch: "LEADING" /* LEADING */
  }), text, /* @__PURE__ */React7.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition: iconPosition,
    iconPositionToMatch: "TRAILING" /* TRAILING */
  }), accessibility && /* @__PURE__ */React7.createElement(UitkText, {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSStandardLink.fragment = fragment2;
EGDSStandardLink.displayName = "EGDSStandardLink";
// src/components/one-key-onboarding/onboarding-sheets/getting-started.tsx
import { ViewMedium as ViewMedium4, Viewport as Viewport4, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
import { UitkButtonSize as UitkButtonSize3 } from "uitk-react-button";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType3 } from "uitk-react-images";
import { UitkSheetContent as UitkSheetContent3 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkText as UitkText6 } from "uitk-react-text";
// src/hooks/use-impression-tracking.ts
import { useEffect as useEffect2 } from "react";
import { ITrackType, useClickstreamAnalytics } from "@shared-ui/clickstream-analytics-context";
var trackAnalytics = function (clickstreamAnalytics, analytics) {
  var track = clickstreamAnalytics.track;
  var linkName = analytics.linkName,
    referrerId = analytics.referrerId;
  var referrerMessageContent = {
    schemaName: "referrer",
    messageContent: {
      eventType: "impression",
      linkName: linkName,
      referrerId: referrerId
    }
  };
  var messages = [referrerMessageContent];
  track(ITrackType.EVENT, {
    data: messages
  });
};
var useImpressionTracking = function (analytics) {
  var clickstreamAnalytics = useClickstreamAnalytics();
  useEffect2(function () {
    if (analytics) {
      trackAnalytics(clickstreamAnalytics, analytics);
    }
  }, []);
};
// src/components/one-key-onboarding/common/fragments.ts
import { gql as gql8 } from "@apollo/client";
var OnboardingButtonAction = gql8(_templateObject7());
// src/components/one-key-onboarding/common/terms-and-conditions-consent-button.tsx
import React18, { useCallback as useCallback8, useEffect as useEffect5 } from "react";
import { useLoggerEvents as useLoggerEvents5 } from "@shared-ui/logger-context";
import { UitkButtonSize as UitkButtonSize2 } from "uitk-react-button";
// src/hooks/use-handle-operation-response.ts
import { useCallback as useCallback3 } from "react";
import { useLoggerEvents } from "@shared-ui/logger-context";
import { liveAnnounce } from "uitk-react-utils";
// src/components/one-key-onboarding/providers/onboarding-dialog-provider.tsx
import React8, { createContext, useCallback, useContext, useMemo } from "react";
import { useDialog } from "@shared-ui/dialog-context";
var OnboardingDialogContext = createContext({
  isDialogOpen: false,
  openDialog: function () {
    return void 0;
  },
  closeDialog: function () {
    return void 0;
  },
  DialogComponent: function () {
    return null;
  }
});
var OnboardingDialogContextProvider = function (param) {
  var mockedContext = param.mockedContext,
    children = param.children;
  var _useDialog = _sliced_to_array(useDialog("one-key-onboarding-dialog", void 0, false), 3),
    isDialogOpen = _useDialog[0],
    dialogActions = _useDialog[1],
    DialogComponent = _useDialog[2];
  var openDialog = useCallback(function () {
    dialogActions.openDialog();
  }, [dialogActions]);
  var closeDialog = useCallback(function () {
    dialogActions.closeDialog();
  }, [dialogActions]);
  var defaultContext = useMemo(function () {
    return {
      isDialogOpen: isDialogOpen,
      openDialog: openDialog,
      closeDialog: closeDialog,
      DialogComponent: DialogComponent
    };
  }, [isDialogOpen, openDialog, closeDialog, DialogComponent]);
  return /* @__PURE__ */React8.createElement(OnboardingDialogContext.Provider, {
    value: mockedContext || defaultContext
  }, children);
};
var useOnboardingDialogContext = function () {
  return useContext(OnboardingDialogContext);
};
// src/components/one-key-onboarding/providers/onboarding-screens-provider.tsx
import React9, { createContext as createContext2, useCallback as useCallback2, useContext as useContext2, useMemo as useMemo2, useState as useState2 } from "react";
var OnboardingScreensContext = createContext2({
  currentScreen: null,
  getIsLastScreen: function () {
    return false;
  },
  navigateToNextScreen: function () {
    return void 0;
  },
  addScreen: function () {
    return void 0;
  },
  setScreens: function () {
    return void 0;
  }
});
var getScreenResult = function (result) {
  if (result.__typename === "OneKeyOnboardingSheet") {
    return result.element;
  }
  return result.screen;
};
var OnboardingScreensProvider = function (param) {
  var mockedContext = param.mockedContext,
    children = param.children;
  var _useState2 = _sliced_to_array(useState2({
      screens: [],
      currentScreen: null,
      currentScreenIndex: 0
    }), 2),
    onboardingScreensState = _useState2[0],
    setOnboardingScreensState = _useState2[1];
  var getIsLastScreen = useCallback2(function () {
    return onboardingScreensState.currentScreenIndex === onboardingScreensState.screens.length - 1;
  }, [onboardingScreensState]);
  var navigateToNextScreen = useCallback2(function () {
    setOnboardingScreensState(function (prevState) {
      var nextScreenIndex = prevState.currentScreenIndex + 1;
      if (prevState.screens[nextScreenIndex]) {
        return _object_spread_props(_object_spread({}, prevState), {
          currentScreen: getScreenResult(prevState.screens[nextScreenIndex]),
          currentScreenIndex: nextScreenIndex
        });
      }
      return prevState;
    });
  }, []);
  var addScreen = useCallback2(function (screen) {
    setOnboardingScreensState(function (prevState) {
      return _object_spread_props(_object_spread({}, prevState), {
        screens: _to_consumable_array(prevState.screens).concat([screen])
      });
    });
  }, []);
  var setScreens = useCallback2(function (screens) {
    setOnboardingScreensState(function (prevState) {
      return _object_spread_props(_object_spread({}, prevState), {
        screens: screens,
        currentScreen: screens[0] ? getScreenResult(screens[0]) : null,
        currentScreenIndex: 0
      });
    });
  }, []);
  var context = useMemo2(function () {
    return {
      currentScreen: onboardingScreensState.currentScreen,
      getIsLastScreen: getIsLastScreen,
      navigateToNextScreen: navigateToNextScreen,
      addScreen: addScreen,
      setScreens: setScreens
    };
  }, [onboardingScreensState, getIsLastScreen, navigateToNextScreen, addScreen, setScreens]);
  return /* @__PURE__ */React9.createElement(OnboardingScreensContext.Provider, {
    value: mockedContext || context
  }, children);
};
var useOnboardingScreensContext = function () {
  return useContext2(OnboardingScreensContext);
};
// src/hooks/use-handle-operation-response.ts
var useHandleOperationResponse = function () {
  var closeDialog = useOnboardingDialogContext().closeDialog;
  var _useOnboardingScreensContext = useOnboardingScreensContext(),
    navigateToNextScreen = _useOnboardingScreensContext.navigateToNextScreen,
    addScreen = _useOnboardingScreensContext.addScreen;
  var systemEvents = useLoggerEvents(LOGGER_EVENTS);
  var handleOperationResponse = useCallback3(function (operationResponse) {
    var data = (operationResponse || {}).data;
    var _ref = (data === null || data === void 0 ? void 0 : data.oneKeyOnboardingOperation) || {},
      operationStatus = _ref.operationStatus,
      operationResult = _ref.operationResult;
    if (operationResult === null && operationStatus === "SUCCEEDED" /* SUCCEEDED */) {
      navigateToNextScreen();
      return;
    }
    if (operationStatus === "FAILED" /* FAILED */) {
      systemEvents.ONE_KEY_ONBOARDING_GENERIC_MUTATION_ERROR.log(stringifyEventPayload({
        message: "OnboardingOperation mutation error. operationStatus: FAILED" /* FAILED */
      }));
      navigateToErrorPage();
      return;
    }
    switch (operationResult === null || operationResult === void 0 ? void 0 : operationResult.__typename) {
      case "OneKeyContextualOnboarding":
        {
          addScreen({
            __typename: "OneKeyOnboardingSheet",
            element: _object_spread({}, operationResult)
          });
          navigateToNextScreen();
          return;
        }
      case "OneKeyOnboardingInterstitialLoading":
        {
          addScreen({
            __typename: "OneKeyOnboardingSheet",
            element: _object_spread({}, operationResult)
          });
          navigateToNextScreen();
          return;
        }
      case "UILinkAction":
        {
          var accessibility = operationResult.accessibility;
          liveAnnounce(accessibility || void 0);
          navigateToLink(operationResult);
          return;
        }
      case "EGDSDismissAction":
        {
          var accessibility1 = operationResult.accessibility;
          liveAnnounce(accessibility1 || void 0);
          closeDialog();
          return;
        }
      default:
        {
          systemEvents.ONE_KEY_ONBOARDING_GENERIC_MUTATION_ERROR.log(stringifyEventPayload({
            message: "OnboardingOperation mutation error. Invalid operationResult or typename: ".concat(JSON.stringify(operationResult))
          }));
          navigateToErrorPage();
        }
    }
  }, [navigateToNextScreen, addScreen, systemEvents, closeDialog]);
  return {
    handleOperationResponse: handleOperationResponse
  };
};
// src/hooks/use-onboarding-operation.ts
import { gql as gql13, useMutation } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
// src/components/one-key-onboarding/onboarding-sheets/contextual-onboarding.tsx
import React15, { useCallback as useCallback6 } from "react";
import { gql as gql11 } from "@apollo/client";
import { useLoggerEvents as useLoggerEvents3 } from "@shared-ui/logger-context";
// ../internal/src/components/egds-card/egds-card.tsx
import React11 from "react";
import { gql as gql10 } from "@apollo/client";
// ../internal/src/components/egds-card/egds-mark-card.tsx
import React10 from "react";
import { gql as gql9 } from "@apollo/client";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText as UitkText2 } from "uitk-react-text";
var __EGDSMarkCardFragment = gql9(_templateObject8(), EGDSMark.fragment);
var EGDSMarkCard = function (param) {
  var data = param.data,
    externalMargin = param.externalMargin,
    _param_markSize = param.markSize,
    markSize = _param_markSize === void 0 ? 18 : _param_markSize;
  var mark = data.mark,
    subTitle = data.subTitle,
    title = data.title;
  var cardMargin = externalMargin;
  var cardContentPadding = {
    inline: "six",
    block: "sixteen"
  };
  var markMargin = {
    blockend: "six",
    inline: "sixteen"
  };
  var subTitleMargin = {
    blockend: "two",
    blockstart: "four"
  };
  return /* @__PURE__ */React10.createElement(UitkSpacing, {
    margin: cardMargin
  }, /* @__PURE__ */React10.createElement(UitkCard, {
    border: true
  }, /* @__PURE__ */React10.createElement(UitkCardContentSection, {
    padded: []
  }, /* @__PURE__ */React10.createElement(UitkSpacing, {
    padding: cardContentPadding
  }, /* @__PURE__ */React10.createElement(UitkLayoutFlex, {
    wrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    direction: "column"
  }, /* @__PURE__ */React10.createElement(UitkLayoutFlexItem, {
    alignSelf: "center"
  }, /* @__PURE__ */React10.createElement(UitkSpacing, {
    margin: markMargin
  }, mark && /* @__PURE__ */React10.createElement(EGDSMark, {
    data: mark,
    markSize: markSize
  }))), /* @__PURE__ */React10.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React10.createElement(UitkSpacing, {
    margin: subTitleMargin
  }, /* @__PURE__ */React10.createElement(UitkText2, {
    size: 400,
    weight: "medium",
    align: "center"
  }, title))), /* @__PURE__ */React10.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React10.createElement(UitkText2, {
    size: 600,
    weight: "bold",
    align: "center"
  }, subTitle)))))));
};
EGDSMarkCard.displayName = "EGDSMarkCard";
EGDSMarkCard.fragment = __EGDSMarkCardFragment;
// ../internal/src/components/egds-card/egds-card.tsx
var __EGDSCardFragment = gql10(_templateObject9(), EGDSMarkCard.fragment);
var EGDSCard = function (param) {
  var className = param.className,
    data = param.data,
    externalMargin = param.externalMargin;
  switch (data.__typename) {
    case "EGDSMarkCard":
      return /* @__PURE__ */React11.createElement(EGDSMarkCard, {
        className: className,
        data: data,
        externalMargin: externalMargin
      });
    default:
      return null;
  }
};
EGDSCard.displayName = "EGDSCard";
EGDSCard.fragment = __EGDSCardFragment;
// src/components/one-key-onboarding/onboarding-sheets/contextual-onboarding.tsx
import { ViewMedium as ViewMedium2, Viewport as Viewport2 } from "@shared-ui/viewport-context";
import { UitkButtonSize } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkSheet, UitkSheetContent } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading, UitkText as UitkText3 } from "uitk-react-text";
// src/components/one-key-onboarding/common/onboarding-header.tsx
import React13, { useCallback as useCallback5, useEffect as useEffect3 } from "react";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useLoggerEvents as useLoggerEvents2 } from "@shared-ui/logger-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkTertiaryButton } from "uitk-react-button";
import { GlobalNavigationRow, GlobalNavigationSiteHeader } from "uitk-react-global-navigation";
import { UitkIcon as UitkIcon2 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkMarkSize as UitkMarkSize2 } from "uitk-react-mark";
// src/components/one-key-onboarding/providers/mutation-progress-provider.tsx
import React12, { createContext as createContext3, useCallback as useCallback4, useContext as useContext3, useMemo as useMemo3, useState as useState3 } from "react";
var MutationProgressContext = createContext3({
  isMutationInProgress: false,
  setIsMutationInProgress: function () {
    return void 0;
  }
});
var MutationProgressProvider = function (param) {
  var mockedContext = param.mockedContext,
    children = param.children;
  var _useState3 = _sliced_to_array(useState3(false), 2),
    isMutationInProgress = _useState3[0],
    setIsMutationInProgress = _useState3[1];
  var handleMutationProgressChange = useCallback4(function (state) {
    setIsMutationInProgress(state);
  }, []);
  var context = useMemo3(function () {
    return {
      isMutationInProgress: isMutationInProgress,
      setIsMutationInProgress: handleMutationProgressChange
    };
  }, [isMutationInProgress, handleMutationProgressChange]);
  return /* @__PURE__ */React12.createElement(MutationProgressContext.Provider, {
    value: mockedContext || context
  }, children);
};
var useMutationProgressContext = function () {
  return useContext3(MutationProgressContext);
};
// src/components/one-key-onboarding/common/onboarding-header.tsx
var OnboardingHeader = function (param) {
  var dismissButton = param.dismissButton,
    headerBrandLogo = param.headerBrandLogo,
    onDismissOperation = param.onDismissOperation;
  var _useMutationProgressContext = useMutationProgressContext(),
    isMutationInProgress = _useMutationProgressContext.isMutationInProgress,
    setIsMutationInProgress = _useMutationProgressContext.setIsMutationInProgress;
  var clickTracker = useClickTracker3();
  var systemEvents = useLoggerEvents2(LOGGER_EVENTS);
  var handleOperationResponse = useHandleOperationResponse().handleOperationResponse;
  var _useOnboardingOperation = _sliced_to_array(useOnboardingOperation(onDismissOperation), 2),
    dismissClicked = _useOnboardingOperation[0],
    _useOnboardingOperation_ = _useOnboardingOperation[1],
    isDismissCalled = _useOnboardingOperation_.called;
  useEffect3(function () {
    setIsMutationInProgress(isDismissCalled);
  }, [setIsMutationInProgress, isDismissCalled]);
  var handleOnDismiss = useCallback5(function () {
    if (dismissButton === null || dismissButton === void 0 ? void 0 : dismissButton.analytics) {
      var _dismissButton_analytics = dismissButton.analytics,
        referrerId = _dismissButton_analytics.referrerId,
        linkName = _dismissButton_analytics.linkName;
      clickTracker(referrerId, linkName);
    }
    dismissClicked().then(function (response) {
      handleOperationResponse(response);
    }).catch(function (error) {
      systemEvents.ONE_KEY_ONBOARDING_HEADER_DISMISS_MUTATION_ERROR.log(stringifyEventPayload({
        message: "Onboarding Header ".concat(getOnboardingActionType(onDismissOperation), " mutation error"),
        error: error
      }));
      navigateToErrorPage();
    });
  }, [dismissButton, clickTracker, dismissClicked, handleOperationResponse, systemEvents, onDismissOperation]);
  if (!headerBrandLogo) {
    return null;
  }
  return /* @__PURE__ */React13.createElement(UitkLayoutPosition, {
    type: "relative"
  }, /* @__PURE__ */React13.createElement(GlobalNavigationSiteHeader, null, /* @__PURE__ */React13.createElement(GlobalNavigationRow, null, /* @__PURE__ */React13.createElement(UitkLayoutFlex2, {
    justifyContent: "center"
  }, /* @__PURE__ */React13.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React13.createElement(Viewport, null, /* @__PURE__ */React13.createElement(ViewSmall, null, /* @__PURE__ */React13.createElement(EGDSGraphic, {
    data: headerBrandLogo,
    markSize: UitkMarkSize2.MEDIUM
  })), /* @__PURE__ */React13.createElement(ViewMedium, null, /* @__PURE__ */React13.createElement(EGDSGraphic, {
    data: headerBrandLogo,
    markSize: 7
  }))))), dismissButton && /* @__PURE__ */React13.createElement(UitkLayoutPosition, {
    type: "absolute",
    position: {
      top: "center",
      left: "two"
    },
    cloneElement: true
  }, /* @__PURE__ */React13.createElement(UitkTertiaryButton, {
    disabled: isMutationInProgress,
    onClick: handleOnDismiss
  }, /* @__PURE__ */React13.createElement(UitkIcon2, {
    name: "close",
    description: dismissButton.accessibility || ""
  }))))));
};
// src/components/one-key-onboarding/onboarding-sheets/brand-logos.tsx
import React14 from "react";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkMarkSize as UitkMarkSize3 } from "uitk-react-mark";
var BrandLogos = function (param) {
  var logos = param.logos,
    className = param.className;
  return /* @__PURE__ */React14.createElement(UitkLayoutFlex3, {
    className: className,
    justifyContent: "center",
    alignItems: "center",
    space: "three"
  }, logos.map(function (logo) {
    return /* @__PURE__ */React14.createElement(UitkLayoutFlexItem3, {
      key: logo.description
    }, /* @__PURE__ */React14.createElement(EGDSGraphic, {
      data: logo,
      markSize: UitkMarkSize3.SMALL
    }));
  }));
};
// src/components/one-key-onboarding/onboarding-sheets/contextual-onboarding.tsx
var fragment3 = gql11(_templateObject10(), EGDSGraphic.fragment, EGDSIcon2.fragment, EGDSStandardLink.fragment, EGDSCard.fragment, EGDSButton.fragment, OnboardingButtonAction);
var ContextualOnboarding = function (param) {
  var data = param.data;
  var titleImage = data.titleImage,
    brandLogos = data.brandLogos,
    oneKeyCard = data.oneKeyCard,
    title = data.title,
    subText = data.subText,
    link = data.link,
    primaryButton = data.primaryButton,
    headerBrandLogo = data.headerBrandLogo;
  var impressionTracking = {
    linkName: "Contextual Onboarding Page in the One Key Onboarding flow has been viewed",
    referrerId: "OneKey.Onboarding.ContextualOnboarding"
  };
  useImpressionTracking(impressionTracking);
  var systemEvents = useLoggerEvents3(LOGGER_EVENTS);
  var isDialogOpen = useOnboardingDialogContext().isDialogOpen;
  var handleOperationResponse = useHandleOperationResponse().handleOperationResponse;
  var _useOnboardingOperation = _sliced_to_array(useOnboardingOperation(primaryButton.action), 2),
    contextualOnboardingSeen = _useOnboardingOperation[0],
    _useOnboardingOperation_ = _useOnboardingOperation[1],
    isContextualOnboardingSeenCalled = _useOnboardingOperation_.called;
  var handleClick = useCallback6(function () {
    contextualOnboardingSeen().then(function (response) {
      var _response_data_oneKeyOnboardingOperation_operationResult, _response_data;
      if (((_response_data = response.data) === null || _response_data === void 0 ? void 0 : (_response_data_oneKeyOnboardingOperation_operationResult = _response_data.oneKeyOnboardingOperation.operationResult) === null || _response_data_oneKeyOnboardingOperation_operationResult === void 0 ? void 0 : _response_data_oneKeyOnboardingOperation_operationResult.__typename) === "EGDSDismissAction") {
        window.location.reload();
      } else {
        handleOperationResponse(response);
      }
    }).catch(function (error) {
      systemEvents.ONE_KEY_ONBOARDING_CONTEXTUAL_ONBOARDING_MUTATION_ERROR.log(stringifyEventPayload({
        message: "Contextual Onboarding ".concat(getOnboardingActionType(primaryButton.action), " mutation error"),
        error: error
      }));
      navigateToErrorPage();
    });
  }, [contextualOnboardingSeen, handleOperationResponse, systemEvents, primaryButton.action]);
  var header = headerBrandLogo && /* @__PURE__ */React15.createElement(Viewport2, null, /* @__PURE__ */React15.createElement(ViewMedium2, null, /* @__PURE__ */React15.createElement(OnboardingHeader, {
    headerBrandLogo: headerBrandLogo,
    onDismissOperation: null
  })));
  var oneKeyCardComponent = /* @__PURE__ */React15.createElement(UitkLayoutFlex4, {
    justifyContent: "center"
  }, /* @__PURE__ */React15.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */React15.createElement(EGDSCard, {
    data: oneKeyCard,
    externalMargin: {
      inlineend: "six",
      inlinestart: "six"
    }
  })));
  return /* @__PURE__ */React15.createElement(UitkSheet, {
    isVisible: isDialogOpen,
    triggerRef: null,
    type: "full"
  }, header, /* @__PURE__ */React15.createElement(UitkSheetContent, null, /* @__PURE__ */React15.createElement(UitkLayoutFlex4, {
    direction: "column",
    alignItems: "center",
    tag: "main"
  }, /* @__PURE__ */React15.createElement(UitkLayoutFlexItem4, {
    alignSelf: "center",
    maxWidth: "one_hundred_twelve"
  }, /* @__PURE__ */React15.createElement(UitkSpacing2, {
    padding: {
      inline: "six"
    }
  }, /* @__PURE__ */React15.createElement("div", null, /* @__PURE__ */React15.createElement(UitkLayoutFlex4, {
    justifyContent: "center"
  }, /* @__PURE__ */React15.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */React15.createElement(EGDSMark, {
    data: titleImage,
    markSize: 11
  }))), /* @__PURE__ */React15.createElement(UitkSpacing2, {
    margin: {
      blockstart: "four",
      blockend: "six"
    },
    padding: {
      blockend: "two"
    }
  }, /* @__PURE__ */React15.createElement(BrandLogos, {
    logos: brandLogos
  })), oneKeyCardComponent, /* @__PURE__ */React15.createElement(UitkSpacing2, {
    margin: {
      blockend: "four",
      blockstart: "six"
    },
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React15.createElement(UitkHeading, {
    size: 4,
    align: "center"
  }, title)), /* @__PURE__ */React15.createElement(UitkText3, {
    align: "center",
    size: 400
  }, subText), /* @__PURE__ */React15.createElement(UitkSpacing2, {
    margin: {
      blockstart: "six"
    },
    padding: {
      block: "three"
    }
  }, /* @__PURE__ */React15.createElement(EGDSStandardLink, {
    data: link,
    align: "center"
  })), /* @__PURE__ */React15.createElement(UitkSpacing2, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React15.createElement(EGDSButton, {
    isFullWidth: true,
    isDisabled: isContextualOnboardingSeenCalled,
    data: primaryButton.button,
    onClickHandler: handleClick,
    size: UitkButtonSize.LARGE
  }))))))));
};
ContextualOnboarding.fragment = fragment3;
ContextualOnboarding.displayName = "ContextualOnboarding";
// src/components/one-key-onboarding/onboarding-sheets/interstitial-loading.tsx
import React16, { useCallback as useCallback7, useEffect as useEffect4, useState as useState4 } from "react";
import { gql as gql12 } from "@apollo/client";
import { useLoggerEvents as useLoggerEvents4 } from "@shared-ui/logger-context";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkLoader } from "uitk-react-loader";
import { UitkSheet as UitkSheet2, UitkSheetContent as UitkSheetContent2 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkText as UitkText4 } from "uitk-react-text";
import { liveAnnounce as liveAnnounce2 } from "uitk-react-utils";
var fragment4 = gql12(_templateObject11(), EGDSGraphic.fragment, EGDSButton.fragment, OnboardingButtonAction);
var InterstitialLoading = function (param) {
  var data = param.data;
  var titleMessage = data.titleMessage,
    titleImage = data.titleImage,
    brandLogos = data.brandLogos,
    welcomeMessage = data.welcomeMessage,
    waitingMessage = data.waitingMessage,
    timeoutMessage = data.timeoutMessage,
    onLoadOperation = data.onLoadOperation,
    primaryButton = data.primaryButton,
    headerBrandLogo = data.headerBrandLogo;
  var _useState4 = _sliced_to_array(useState4(true), 2),
    shouldShowLoading = _useState4[0],
    setShouldShowLoading = _useState4[1];
  var _useState41 = _sliced_to_array(useState4(false), 2),
    shouldShowTimeout = _useState41[0],
    setShouldShowTimeout = _useState41[1];
  var _useOnboardingDialogContext = useOnboardingDialogContext(),
    isDialogOpen = _useOnboardingDialogContext.isDialogOpen,
    closeDialog = _useOnboardingDialogContext.closeDialog;
  var handleOperationResponse = useHandleOperationResponse().handleOperationResponse;
  var _useOnboardingOperation = _sliced_to_array(useOnboardingOperation(onLoadOperation), 1),
    oneKeyMigration = _useOnboardingOperation[0];
  var impressionTracking = {
    linkName: "Interstitial Loading Page in the One Key Onboarding flow has been viewed",
    referrerId: "OneKey.Onboarding.InterstitialLoading"
  };
  useImpressionTracking(impressionTracking);
  var systemEvents = useLoggerEvents4(LOGGER_EVENTS);
  useEffect4(function () {
    var showTimeOutSpinnerAndMessage = setTimeout(function () {
      setShouldShowLoading(false);
      setShouldShowTimeout(true);
    }, 11e3);
    oneKeyMigration().then(function (response) {
      var _response_data;
      clearTimeout(showTimeOutSpinnerAndMessage);
      if (((_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.oneKeyOnboardingOperation.operationStatus) === "TIMED_OUT" /* TIMED_OUT */) {
        setShouldShowLoading(false);
        setShouldShowTimeout(true);
      } else {
        handleOperationResponse(response);
      }
    }).catch(function (error) {
      systemEvents.ONE_KEY_ONBOARDING_INTERSTITIAL_LOADING_MUTATION_ERROR.log(stringifyEventPayload({
        message: "Interstitial Loading ".concat(getOnboardingActionType(onLoadOperation), " mutation error"),
        error: error
      }));
      navigateToErrorPage();
    });
  }, []);
  var handleTimeoutButtonAction = useCallback7(function () {
    var action = primaryButton.action;
    switch (action === null || action === void 0 ? void 0 : action.__typename) {
      case "UILinkAction":
        {
          var accessibility = action.accessibility;
          liveAnnounce2(accessibility || void 0);
          navigateToLink(action);
          return;
        }
      case "EGDSDismissAction":
        {
          var accessibility1 = action.accessibility;
          liveAnnounce2(accessibility1 || void 0);
          closeDialog();
          return;
        }
      default:
        {
          systemEvents.ONE_KEY_ONBOARDING_INTERSTITIAL_LOADING_TIMEOUT_ACTION_ERROR.log(stringifyEventPayload({
            message: "Interstitial Loading timeout action error. Invalid action or typename: ".concat(JSON.stringify(primaryButton.action))
          }));
          navigateToErrorPage();
        }
    }
  }, [primaryButton, closeDialog, systemEvents]);
  var title = /* @__PURE__ */React16.createElement(React16.Fragment, null, /* @__PURE__ */React16.createElement(UitkText4, {
    size: 500,
    weight: "medium",
    align: "center"
  }, titleMessage), /* @__PURE__ */React16.createElement(UitkSpacing3, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React16.createElement(UitkLayoutFlex5, {
    justifyContent: "center"
  }, /* @__PURE__ */React16.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */React16.createElement(EGDSMark, {
    data: titleImage,
    markSize: 11
  })))));
  var loadingMessage = shouldShowLoading && /* @__PURE__ */React16.createElement(UitkSpacing3, {
    margin: {
      blockstart: "four"
    },
    padding: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React16.createElement(UitkLayoutFlex5, {
    direction: "column",
    alignItems: "center"
  }, /* @__PURE__ */React16.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */React16.createElement(UitkText4, {
    size: 500,
    weight: "medium",
    align: "center"
  }, waitingMessage)), /* @__PURE__ */React16.createElement(UitkSpacing3, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React16.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */React16.createElement(UitkLoader, null)))));
  var timeout = shouldShowTimeout && /* @__PURE__ */React16.createElement(React16.Fragment, null, /* @__PURE__ */React16.createElement(UitkSpacing3, {
    margin: {
      blockstart: "sixteen"
    },
    padding: {
      block: "four"
    }
  }, /* @__PURE__ */React16.createElement(UitkText4, {
    size: 500,
    weight: "medium",
    align: "center"
  }, timeoutMessage)), /* @__PURE__ */React16.createElement(UitkSpacing3, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React16.createElement(EGDSButton, {
    data: primaryButton.button,
    isFullWidth: true,
    onClickHandler: handleTimeoutButtonAction
  })));
  return /* @__PURE__ */React16.createElement(UitkSheet2, {
    isVisible: isDialogOpen,
    triggerRef: null,
    type: "full"
  }, /* @__PURE__ */React16.createElement(OnboardingHeader, {
    headerBrandLogo: headerBrandLogo,
    onDismissOperation: null
  }), /* @__PURE__ */React16.createElement(UitkSheetContent2, null, /* @__PURE__ */React16.createElement(UitkLayoutFlex5, {
    direction: "column",
    alignItems: "center",
    tag: "main"
  }, /* @__PURE__ */React16.createElement(UitkLayoutFlexItem5, {
    alignSelf: "center",
    maxWidth: "one_hundred_twelve"
  }, /* @__PURE__ */React16.createElement(UitkSpacing3, {
    padding: {
      inline: "six"
    }
  }, /* @__PURE__ */React16.createElement("div", null, title, /* @__PURE__ */React16.createElement(UitkSpacing3, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React16.createElement(BrandLogos, {
    logos: brandLogos
  })), /* @__PURE__ */React16.createElement(UitkSpacing3, {
    margin: {
      blockstart: "four"
    },
    padding: {
      blockstart: "four",
      inline: "six"
    }
  }, /* @__PURE__ */React16.createElement(UitkText4, {
    size: 500,
    weight: "medium",
    align: "center"
  }, welcomeMessage)), loadingMessage, timeout))))));
};
InterstitialLoading.fragment = fragment4;
InterstitialLoading.displayName = "InterstitialLoading";
// src/components/one-key-onboarding/providers/additional-context-provider.tsx
import React17, { createContext as createContext4, useContext as useContext4, useMemo as useMemo4 } from "react";
var AdditionalContext = createContext4({
  additionalContext: void 0
});
var AdditionalContextProvider = function (param) {
  var additionalContext = param.additionalContext,
    children = param.children;
  var context = useMemo4(function () {
    return {
      additionalContext: additionalContext
    };
  }, [additionalContext]);
  return /* @__PURE__ */React17.createElement(AdditionalContext.Provider, {
    value: context
  }, children);
};
var useAdditionalContext = function () {
  return useContext4(AdditionalContext);
};
// src/hooks/use-onboarding-operation.ts
var onboardingOperation = gql13(_templateObject12(), ContextualOnboarding.fragment, InterstitialLoading.fragment);
var useOnboardingOperation = function (oneKeyOnboardingAction) {
  var context = useBexApi2().context;
  var additionalContext = useAdditionalContext().additionalContext;
  var actionType = getOnboardingActionType(oneKeyOnboardingAction);
  var addContext = additionalContext && ((additionalContext === null || additionalContext === void 0 ? void 0 : additionalContext.cmsToken) || (additionalContext === null || additionalContext === void 0 ? void 0 : additionalContext.originUrl)) ? {
    cmsToken: additionalContext === null || additionalContext === void 0 ? void 0 : additionalContext.cmsToken,
    originUrl: additionalContext === null || additionalContext === void 0 ? void 0 : additionalContext.originUrl
  } : null;
  return useMutation(onboardingOperation, {
    variables: {
      context: context,
      onboardingOperation: actionType,
      additionalContext: addContext
    }
  });
};
// src/components/one-key-onboarding/common/terms-and-conditions-consent-button.tsx
var TermsAndConditionsConsentButton = function (param) {
  var button = param.button,
    className = param.className;
  var systemEvents = useLoggerEvents5(LOGGER_EVENTS);
  var _useMutationProgressContext = useMutationProgressContext(),
    isMutationInProgress = _useMutationProgressContext.isMutationInProgress,
    setIsMutationInProgress = _useMutationProgressContext.setIsMutationInProgress;
  var _useOnboardingOperation = _sliced_to_array(useOnboardingOperation(button.action), 2),
    termsAndConditionsConsented = _useOnboardingOperation[0],
    _useOnboardingOperation_ = _useOnboardingOperation[1],
    isTermsAndConditionsConsentedCalled = _useOnboardingOperation_.called;
  var handleOperationResponse = useHandleOperationResponse().handleOperationResponse;
  useEffect5(function () {
    setIsMutationInProgress(isTermsAndConditionsConsentedCalled);
  }, [setIsMutationInProgress, isTermsAndConditionsConsentedCalled]);
  var handleTermsConsented = useCallback8(function () {
    termsAndConditionsConsented().then(function (response) {
      handleOperationResponse(response);
    }).catch(function (error) {
      systemEvents.ONE_KEY_ONBOARDING_TERMS_AND_CONDITIONS_ACCEPT_MUTATION_ERROR.log(stringifyEventPayload({
        message: "Terms and Conditions ".concat(getOnboardingActionType(button.action), " mutation error"),
        error: error
      }));
      navigateToErrorPage();
    });
  }, [termsAndConditionsConsented, handleOperationResponse, systemEvents, button.action]);
  return /* @__PURE__ */React18.createElement(EGDSButton, {
    data: button.button,
    className: className,
    isFullWidth: true,
    isDisabled: isMutationInProgress,
    onClickHandler: handleTermsConsented,
    size: UitkButtonSize2.LARGE
  });
};
TermsAndConditionsConsentButton.displayName = "TermsAndConditionsConsentButton";
// src/components/one-key-onboarding/onboarding-sheets/onboarding-sheet-titles.tsx
import React19 from "react";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkText as UitkText5 } from "uitk-react-text";
var OnboardingSheetTitles = function (param) {
  var title = param.title,
    subTitles = param.subTitles;
  return /* @__PURE__ */React19.createElement(React19.Fragment, null, /* @__PURE__ */React19.createElement(UitkSpacing4, {
    padding: {
      blockstart: "two"
    },
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React19.createElement(UitkHeading2, {
    size: 4,
    align: "center"
  }, title)), /* @__PURE__ */React19.createElement(UitkSpacing4, {
    margin: {
      blockstart: "four"
    }
  }, subTitles.map(function (subTitle) {
    return /* @__PURE__ */React19.createElement(UitkText5, {
      key: subTitle
    }, /* @__PURE__ */React19.createElement(UitkText5, {
      size: 500,
      align: "center"
    }, subTitle));
  })));
};
// src/components/one-key-onboarding/onboarding-sheets/sheet-wrapper.tsx
import React20 from "react";
import { ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkSheet as UitkSheet3 } from "uitk-react-sheet";
var SheetWrapper = function (param) {
  var children = param.children,
    _param_hasModal = param.hasModal,
    hasModal = _param_hasModal === void 0 ? false : _param_hasModal,
    _param_hasHeaderLogo = param.hasHeaderLogo,
    hasHeaderLogo = _param_hasHeaderLogo === void 0 ? false : _param_hasHeaderLogo;
  var isDialogOpen = useOnboardingDialogContext().isDialogOpen;
  return /* @__PURE__ */React20.createElement(Viewport3, null, /* @__PURE__ */React20.createElement(ViewSmall2, null, /* @__PURE__ */React20.createElement(UitkSheet3, {
    isVisible: isDialogOpen,
    triggerRef: null,
    type: "full"
  }, children)), /* @__PURE__ */React20.createElement(ViewMedium3, null, /* @__PURE__ */React20.createElement(UitkSheet3, {
    isVisible: isDialogOpen,
    triggerRef: null,
    type: hasHeaderLogo ? "full" : "centered",
    hasModal: hasModal
  }, children)));
};
// src/components/one-key-onboarding/onboarding-sheets/getting-started.tsx
var fragment5 = gql14(_templateObject13(), EGDSButton.fragment, EGDSStandardLink.fragment, EGDSIcon2.fragment, EGDSImage.fragment, EGDSGraphic.fragment, OnboardingButtonAction);
var GettingStarted = function (param) {
  var data = param.data;
  var _primaryButton_action;
  var headerImage = data.headerImage,
    title = data.title,
    subTitles = data.subTitles,
    images = data.images,
    gettingStartedlink = data.gettingStartedlink,
    consentText = data.consentText,
    primaryButton = data.primaryButton;
  var isLinkMarginReduced = Boolean(consentText);
  var navigateToNextScreen = useOnboardingScreensContext().navigateToNextScreen;
  var impressionTracking = {
    linkName: "Generic Onboarding Page in the One Key Onboarding flow has been viewed",
    referrerId: "OneKey.Onboarding.GenericOnboarding"
  };
  useImpressionTracking(impressionTracking);
  var header = headerImage && /* @__PURE__ */React21.createElement(Viewport4, null, /* @__PURE__ */React21.createElement(ViewSmall3, null, /* @__PURE__ */React21.createElement(EGDSImage, {
    data: headerImage,
    roundcorner: true,
    ratio: UitkFigureAspectRatioType3.R1_1,
    placeholderImage: true,
    lazyLoading: "lazy"
  })), /* @__PURE__ */React21.createElement(ViewMedium4, null, /* @__PURE__ */React21.createElement(EGDSImage, {
    data: headerImage,
    roundcorner: true,
    ratio: UitkFigureAspectRatioType3.R21_9,
    placeholderImage: true,
    lazyLoading: "lazy"
  })));
  return /* @__PURE__ */React21.createElement(SheetWrapper, {
    hasModal: true
  }, /* @__PURE__ */React21.createElement(UitkSheetContent3, {
    padded: true
  }, header, /* @__PURE__ */React21.createElement(OnboardingSheetTitles, {
    title: title,
    subTitles: subTitles
  }), /* @__PURE__ */React21.createElement(UitkSpacing5, {
    margin: {
      block: "six"
    }
  }, /* @__PURE__ */React21.createElement(BrandLogos, {
    logos: images
  })), /* @__PURE__ */React21.createElement(UitkSpacing5, {
    margin: {
      blockstart: isLinkMarginReduced ? "six" : "twelve"
    }
  }, /* @__PURE__ */React21.createElement(EGDSStandardLink, {
    data: gettingStartedlink,
    align: "center"
  })), consentText && /* @__PURE__ */React21.createElement(UitkSpacing5, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React21.createElement(UitkText6, {
    align: "center"
  }, consentText)), /* @__PURE__ */React21.createElement(UitkSpacing5, {
    margin: {
      blockstart: "six"
    }
  }, ((_primaryButton_action = primaryButton.action) === null || _primaryButton_action === void 0 ? void 0 : _primaryButton_action.__typename) === "OnboardingOperationAction" && primaryButton.action.actionType === "consented" ? /* @__PURE__ */React21.createElement(TermsAndConditionsConsentButton, {
    button: primaryButton
  }) : /* @__PURE__ */React21.createElement(EGDSButton, {
    isFullWidth: true,
    data: primaryButton.button,
    onClickHandler: navigateToNextScreen,
    size: UitkButtonSize3.LARGE
  }))));
};
GettingStarted.fragment = fragment5;
GettingStarted.displayName = "GettingStarted";
// src/components/one-key-onboarding/onboarding-sheets/terms-and-conditions.tsx
import React22, { useCallback as useCallback9, useEffect as useEffect6 } from "react";
import { gql as gql15 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { useLoggerEvents as useLoggerEvents6 } from "@shared-ui/logger-context";
import { UitkButtonSize as UitkButtonSize4, UitkTertiaryButton as UitkTertiaryButton2 } from "uitk-react-button";
import { UitkIcon as UitkIcon3 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkSheetContent as UitkSheetContent4 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3, UitkText as UitkText7 } from "uitk-react-text";
var fragment6 = gql15(_templateObject14(), EGDSButton.fragment, EGDSGraphic.fragment, EGDSStandardLink.fragment, OnboardingButtonAction);
var TermsAndConditions = function (param) {
  var data = param.data;
  var title = data.title,
    subText = data.subText,
    additionalText = data.additionalText,
    links = data.links,
    images = data.images,
    primaryButton = data.primaryButton,
    secondaryButton = data.secondaryButton,
    dismissButton = data.dismissButton,
    headerBrandLogo = data.headerBrandLogo,
    onDismissOperation = data.onDismissOperation;
  var pageName = secondaryButton ? "OneKey.Onboarding.BetaT&C" : "OneKey.Onboarding.T&C";
  var readablePageName = secondaryButton ? "Beta Terms & Conditions" : "Terms & Conditions";
  var impressionTracking = {
    linkName: "".concat(readablePageName, " Page in the One Key Onboarding flow has been viewed"),
    referrerId: pageName
  };
  useImpressionTracking(impressionTracking);
  var systemEvents = useLoggerEvents6(LOGGER_EVENTS);
  var handleOperationResponse = useHandleOperationResponse().handleOperationResponse;
  var _useMutationProgressContext = useMutationProgressContext(),
    isMutationInProgress = _useMutationProgressContext.isMutationInProgress,
    setIsMutationInProgress = _useMutationProgressContext.setIsMutationInProgress;
  var _useOnboardingOperation = _sliced_to_array(useOnboardingOperation(onDismissOperation), 2),
    termsAndConditionsDeclined = _useOnboardingOperation[0],
    _useOnboardingOperation_ = _useOnboardingOperation[1],
    isTermsAndConditionsDeclinedCalled = _useOnboardingOperation_.called;
  useEffect6(function () {
    setIsMutationInProgress(isTermsAndConditionsDeclinedCalled);
  }, [setIsMutationInProgress, isTermsAndConditionsDeclinedCalled]);
  var clickTracker = useClickTracker4();
  var handleTermsDeclined = useCallback9(function () {
    termsAndConditionsDeclined().then(function (response) {
      handleOperationResponse(response);
    }).catch(function (error) {
      systemEvents.ONE_KEY_ONBOARDING_TERMS_AND_CONDITIONS_DECLINE_MUTATION_ERROR.log(stringifyEventPayload({
        message: "Terms and Conditions ".concat(getOnboardingActionType(onDismissOperation), " mutation error"),
        error: error
      }));
      navigateToErrorPage();
    });
  }, [termsAndConditionsDeclined, handleOperationResponse, systemEvents, onDismissOperation]);
  var handleOnDismiss = useCallback9(function () {
    if (dismissButton === null || dismissButton === void 0 ? void 0 : dismissButton.analytics) {
      var _dismissButton_analytics = dismissButton.analytics,
        referrerId = _dismissButton_analytics.referrerId,
        linkName = _dismissButton_analytics.linkName;
      clickTracker(referrerId, linkName);
    }
    termsAndConditionsDeclined().then(function (response) {
      handleOperationResponse(response);
    }).catch(function (error) {
      systemEvents.ONE_KEY_ONBOARDING_TERMS_AND_CONDITIONS_DISMISS_MUTATION_ERROR.log(stringifyEventPayload({
        message: "Terms and Conditions ".concat(getOnboardingActionType(onDismissOperation), " mutation error"),
        error: error
      }));
      navigateToErrorPage();
    });
  }, [dismissButton, clickTracker, termsAndConditionsDeclined, handleOperationResponse, systemEvents, onDismissOperation]);
  var linksComponent = /* @__PURE__ */React22.createElement(UitkSpacing6, {
    margin: {
      blockend: "sixteen"
    }
  }, /* @__PURE__ */React22.createElement(UitkLayoutFlex6, {
    alignItems: "center",
    justifyContent: "center",
    direction: "column"
  }, links.map(function (link) {
    return /* @__PURE__ */React22.createElement(UitkLayoutFlexItem6, {
      key: link === null || link === void 0 ? void 0 : link.text
    }, /* @__PURE__ */React22.createElement(UitkSpacing6, {
      margin: {
        blockstart: "six"
      }
    }, /* @__PURE__ */React22.createElement(EGDSStandardLink, {
      align: "center",
      data: link
    })));
  })));
  var header = headerBrandLogo && /* @__PURE__ */React22.createElement(OnboardingHeader, {
    dismissButton: dismissButton,
    headerBrandLogo: headerBrandLogo,
    onDismissOperation: onDismissOperation
  });
  var closeButton = !headerBrandLogo && /* @__PURE__ */React22.createElement(UitkLayoutPosition2, {
    type: "relative"
  }, /* @__PURE__ */React22.createElement(UitkLayoutPosition2, {
    type: "absolute",
    position: {
      top: "center",
      right: "minus-four"
    },
    cloneElement: true
  }, dismissButton && onDismissOperation && /* @__PURE__ */React22.createElement(UitkTertiaryButton2, {
    disabled: isMutationInProgress,
    onClick: handleOnDismiss
  }, /* @__PURE__ */React22.createElement(UitkIcon3, {
    name: "close",
    description: dismissButton.accessibility || "Close"
  }))));
  return /* @__PURE__ */React22.createElement(SheetWrapper, {
    hasHeaderLogo: headerBrandLogo !== null
  }, header, /* @__PURE__ */React22.createElement(UitkSheetContent4, {
    padded: true
  }, closeButton, /* @__PURE__ */React22.createElement(UitkLayoutFlex6, {
    direction: "column",
    alignItems: "center",
    tag: "main"
  }, /* @__PURE__ */React22.createElement(UitkLayoutFlexItem6, {
    alignSelf: headerBrandLogo ? "center" : "stretch",
    maxWidth: headerBrandLogo ? "one_hundred_twelve" : void 0
  }, /* @__PURE__ */React22.createElement(UitkSpacing6, {
    padding: headerBrandLogo ? {
      inline: "six"
    } : void 0
  }, /* @__PURE__ */React22.createElement("div", null, /* @__PURE__ */React22.createElement(UitkSpacing6, {
    margin: {
      blockend: "four",
      blockstart: headerBrandLogo ? void 0 : "six"
    }
  }, /* @__PURE__ */React22.createElement(UitkHeading3, {
    size: 4,
    align: "center"
  }, title)), /* @__PURE__ */React22.createElement(UitkSpacing6, {
    margin: {
      block: "six"
    }
  }, /* @__PURE__ */React22.createElement(BrandLogos, {
    logos: images
  })), /* @__PURE__ */React22.createElement(UitkText7, {
    align: "center",
    size: 400
  }, subText), linksComponent, /* @__PURE__ */React22.createElement(UitkSpacing6, {
    padding: {
      block: "six"
    }
  }, /* @__PURE__ */React22.createElement(UitkText7, {
    align: "center"
  }, additionalText)), /* @__PURE__ */React22.createElement(TermsAndConditionsConsentButton, {
    button: primaryButton
  }), secondaryButton && /* @__PURE__ */React22.createElement(UitkSpacing6, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React22.createElement(EGDSButton, {
    data: secondaryButton,
    isFullWidth: true,
    isDisabled: isMutationInProgress,
    onClickHandler: handleTermsDeclined,
    size: UitkButtonSize4.LARGE
  }))))))));
};
TermsAndConditions.fragment = fragment6;
TermsAndConditions.displayName = "TermsAndConditions";
// src/components/one-key-onboarding/onboarding-sheets/account-merge.tsx
import React23, { useCallback as useCallback10 } from "react";
import { gql as gql16 } from "@apollo/client";
import { useLoggerEvents as useLoggerEvents7 } from "@shared-ui/logger-context";
import { UitkButtonSize as UitkButtonSize5 } from "uitk-react-button";
import { UitkCard as UitkCard2, UitkCardContentSection as UitkCardContentSection2 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex7, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkSheetContent as UitkSheetContent5 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
var fragment7 = gql16(_templateObject15(), EGDSButton.fragment, EGDSGraphic.fragment, EGDSStandardLink.fragment, OnboardingButtonAction);
var AccountMerge = function (param) {
  var data = param.data;
  var title = data.title,
    subTitles = data.subTitles,
    images = data.images,
    accountMergelink = data.accountMergelink,
    primaryButton = data.primaryButton,
    headerBrandLogo = data.headerBrandLogo;
  var hasHeaderLogo = headerBrandLogo !== null;
  var handleOperationResponse = useHandleOperationResponse().handleOperationResponse;
  var _useOnboardingOperation = _sliced_to_array(useOnboardingOperation(primaryButton.action), 2),
    oneIdentityMergeUpgrade = _useOnboardingOperation[0],
    _useOnboardingOperation_ = _useOnboardingOperation[1],
    isOneIdentityMergeUpgradeCalled = _useOnboardingOperation_.called;
  var impressionTracking = {
    linkName: "Account Merge Page in the One Key Onboarding flow has been viewed",
    referrerId: "OneKey.Onboarding.AccountMerge"
  };
  useImpressionTracking(impressionTracking);
  var systemEvents = useLoggerEvents7(LOGGER_EVENTS);
  var handleClick = useCallback10(function () {
    oneIdentityMergeUpgrade().then(function (response) {
      handleOperationResponse(response);
    }).catch(function (error) {
      systemEvents.ONE_KEY_ONBOARDING_ACCOUNT_MERGE_MUTATION_ERROR.log(stringifyEventPayload({
        message: "Account Merge ".concat(getOnboardingActionType(primaryButton.action), " mutation error"),
        error: error
      }));
      navigateToErrorPage();
    });
  }, [oneIdentityMergeUpgrade, handleOperationResponse, systemEvents, primaryButton.action]);
  var brandLogos = /* @__PURE__ */React23.createElement(UitkLayoutFlex7, {
    justifyContent: "center"
  }, /* @__PURE__ */React23.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */React23.createElement(UitkCard2, {
    backgroundTheme: "secondary"
  }, /* @__PURE__ */React23.createElement(UitkCardContentSection2, null, /* @__PURE__ */React23.createElement(UitkSpacing7, {
    margin: {
      block: "sixteen"
    }
  }, /* @__PURE__ */React23.createElement(UitkLayoutGrid, {
    columns: 1
  }, images.map(function (image) {
    return /* @__PURE__ */React23.createElement(UitkSpacing7, {
      padding: {
        inline: "six"
      },
      margin: {
        block: "one"
      },
      key: image.description
    }, /* @__PURE__ */React23.createElement(UitkLayoutGridItem, null, /* @__PURE__ */React23.createElement(EGDSGraphic, {
      data: image,
      markSize: 10
    })));
  })))))));
  return /* @__PURE__ */React23.createElement(SheetWrapper, {
    hasHeaderLogo: hasHeaderLogo
  }, headerBrandLogo && /* @__PURE__ */React23.createElement(OnboardingHeader, {
    headerBrandLogo: headerBrandLogo,
    onDismissOperation: null
  }), /* @__PURE__ */React23.createElement(UitkSheetContent5, {
    padded: true
  }, /* @__PURE__ */React23.createElement(UitkLayoutFlex7, {
    direction: "column",
    alignItems: "center",
    tag: "main"
  }, /* @__PURE__ */React23.createElement(UitkLayoutFlexItem7, {
    alignSelf: hasHeaderLogo ? "center" : "stretch",
    maxWidth: hasHeaderLogo ? "one_hundred_twelve" : void 0
  }, /* @__PURE__ */React23.createElement(UitkSpacing7, {
    padding: hasHeaderLogo ? {
      inline: "six"
    } : void 0
  }, /* @__PURE__ */React23.createElement("div", null, brandLogos, /* @__PURE__ */React23.createElement(OnboardingSheetTitles, {
    title: title,
    subTitles: subTitles
  }), accountMergelink && /* @__PURE__ */React23.createElement(UitkSpacing7, {
    margin: {
      blockstart: "six"
    },
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React23.createElement(EGDSStandardLink, {
    data: accountMergelink,
    align: "center"
  })), /* @__PURE__ */React23.createElement(UitkSpacing7, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React23.createElement(EGDSButton, {
    isFullWidth: true,
    isDisabled: isOneIdentityMergeUpgradeCalled,
    data: primaryButton.button,
    onClickHandler: handleClick,
    size: UitkButtonSize5.LARGE
  }))))))));
};
AccountMerge.fragment = fragment7;
AccountMerge.displayName = "AccountMerge";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/welcome-screen.tsx
import React30, { useCallback as useCallback13, useEffect as useEffect8 } from "react";
import { gql as gql22 } from "@apollo/client";
import { EGDSButtonSize } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSSheet, EGDSSheetContent } from "@egds/react-core/sheet";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText } from "@egds/react-core/text";
import { EgClickstreamImpressionTracker } from "@shared-ui/clickstream-analytics-context";
import { useLoggerEvents as useLoggerEvents8 } from "@shared-ui/logger-context";
// src/hooks/use-onboarding-utils.ts
import { useCallback as useCallback11 } from "react";
var useOnboardingUtils = function () {
  var closeDialog = useOnboardingDialogContext().closeDialog;
  var _useOnboardingScreensContext = useOnboardingScreensContext(),
    navigateToNextScreen = _useOnboardingScreensContext.navigateToNextScreen,
    getIsLastScreen = _useOnboardingScreensContext.getIsLastScreen;
  var proceedWithOnboardingFlow = useCallback11(function () {
    if (getIsLastScreen()) {
      closeDialog();
    } else {
      navigateToNextScreen();
    }
  }, [getIsLastScreen, navigateToNextScreen, closeDialog]);
  return {
    proceedWithOnboardingFlow: proceedWithOnboardingFlow
  };
};
// src/hooks/use-universal-onboarding-operation.ts
import { gql as gql17, useMutation as useMutation2 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
var universalOnboardingOperation = gql17(_templateObject16());
var isOperationStatusSucceeded = function (result) {
  var _result_data;
  return ((_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.oneKeyUniversalOnboardingOperation.operationStatus) === "SUCCEEDED" /* SUCCEEDED */;
};
var useUniversalOnboardingOperation = function (onboardingOperation2) {
  var context = useBexApi3().context;
  return useMutation2(universalOnboardingOperation, {
    variables: {
      context: context,
      onboardingOperation: onboardingOperation2
    }
  });
};
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/common/brand-assets.tsx
import React24 from "react";
import { gql as gql18 } from "@apollo/client";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
var fragment8 = gql18(_templateObject17(), EGDSGraphic.fragment);
var BrandAssets = function (param) {
  var data = param.data;
  var titleImage = data.titleImage,
    brandLogos = data.brandLogos;
  return /* @__PURE__ */React24.createElement(EGDSLayoutFlex, {
    direction: "column",
    justifyContent: "center",
    alignItems: "center",
    space: "four"
  }, /* @__PURE__ */React24.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React24.createElement(EGDSGraphic, {
    data: titleImage,
    markSize: 14
  })), brandLogos && /* @__PURE__ */React24.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React24.createElement(EGDSLayoutFlex, {
    justifyContent: "center",
    alignItems: "center",
    space: "four"
  }, brandLogos.map(function (logo) {
    return /* @__PURE__ */React24.createElement(EGDSLayoutFlexItem, {
      key: logo.description
    }, /* @__PURE__ */React24.createElement(EGDSGraphic, {
      data: logo,
      markSize: 6
    }));
  }))));
};
BrandAssets.fragment = fragment8;
BrandAssets.displayName = "BrandAssets";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/common/onboarding-button.tsx
import React25, { useCallback as useCallback12, useEffect as useEffect7 } from "react";
import { gql as gql19 } from "@apollo/client";
import { liveAnnounce as liveAnnounce3 } from "@egds/react-core/utils";
var fragment9 = gql19(_templateObject18(), EGDSButton.fragment);
var OnboardingButton = function (param) {
  var data = param.data,
    size = param.size,
    isFullWidth = param.isFullWidth,
    isNoTextAllowed = param.isNoTextAllowed,
    dataStid = param.dataStid,
    onNullActionClick = param.onNullActionClick,
    onOperationSuccess = param.onOperationSuccess,
    onOperationFailure = param.onOperationFailure,
    onOperationError = param.onOperationError;
  var closeDialog = useOnboardingDialogContext().closeDialog;
  var proceedWithOnboardingFlow = useOnboardingUtils().proceedWithOnboardingFlow;
  var _useMutationProgressContext = useMutationProgressContext(),
    isMutationInProgress = _useMutationProgressContext.isMutationInProgress,
    setIsMutationInProgress = _useMutationProgressContext.setIsMutationInProgress;
  var _useUniversalOnboardingOperation = _sliced_to_array(useUniversalOnboardingOperation(getUniversalOnboardingActionType(data.action)), 2),
    onboardingOperation2 = _useUniversalOnboardingOperation[0],
    _useUniversalOnboardingOperation_ = _useUniversalOnboardingOperation[1],
    isOnboardingOperationInProgress = _useUniversalOnboardingOperation_.loading;
  useEffect7(function () {
    setIsMutationInProgress(isOnboardingOperationInProgress);
  }, [setIsMutationInProgress, isOnboardingOperationInProgress]);
  var handleOperationResult = useCallback12(function (result) {
    var _result_data;
    switch ((_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.oneKeyUniversalOnboardingOperation.operationStatus) {
      case "SUCCEEDED" /* SUCCEEDED */:
        onOperationSuccess === null || onOperationSuccess === void 0 ? void 0 : onOperationSuccess();
        break;
      case "FAILED" /* FAILED */:
        onOperationFailure === null || onOperationFailure === void 0 ? void 0 : onOperationFailure(result);
        break;
      case "FAILED_BLOCKING" /* FAILED_BLOCKING */:
        onOperationFailure === null || onOperationFailure === void 0 ? void 0 : onOperationFailure(result);
        navigateToErrorPage();
        break;
      default:
        onOperationFailure === null || onOperationFailure === void 0 ? void 0 : onOperationFailure(result);
    }
  }, [onOperationSuccess, onOperationFailure]);
  var handleDismissAction = useCallback12(function () {
    closeDialog();
  }, [closeDialog]);
  var handleUILinkAction = useCallback12(function (action) {
    liveAnnounce3(action.accessibility || void 0);
    navigateToLink(action);
  }, []);
  var handleSecondaryActionOrFallbackAction = useCallback12(function (fallbackAction) {
    var _data_secondaryAction;
    switch ((_data_secondaryAction = data.secondaryAction) === null || _data_secondaryAction === void 0 ? void 0 : _data_secondaryAction.__typename) {
      case "EGDSDismissAction":
        handleDismissAction();
        return;
      case "UILinkAction":
        handleUILinkAction(data.secondaryAction);
        return;
      default:
        fallbackAction();
    }
  }, [data.secondaryAction, handleDismissAction, handleUILinkAction]);
  var handleClick = useCallback12(function () {
    var _data_action;
    switch ((_data_action = data.action) === null || _data_action === void 0 ? void 0 : _data_action.__typename) {
      case "OneKeyUniversalOnboardingOperationAction":
        onboardingOperation2().then(function (result) {
          handleOperationResult(result);
          handleSecondaryActionOrFallbackAction(proceedWithOnboardingFlow);
        }).catch(function (error) {
          onOperationError === null || onOperationError === void 0 ? void 0 : onOperationError(error);
          navigateToErrorPage();
        });
        return;
      case "EGDSDismissAction":
        handleDismissAction();
        return;
      case "UILinkAction":
        handleUILinkAction(data.action);
        return;
      default:
        handleSecondaryActionOrFallbackAction(onNullActionClick);
    }
  }, [data.action, onboardingOperation2, handleOperationResult, handleSecondaryActionOrFallbackAction, proceedWithOnboardingFlow, onOperationError, handleDismissAction, handleUILinkAction, onNullActionClick]);
  return /* @__PURE__ */React25.createElement(EGDSButton, {
    data: data.button,
    isDisabled: isMutationInProgress,
    isFullWidth: isFullWidth,
    size: size,
    isNoTextAllowed: isNoTextAllowed,
    dataStid: dataStid,
    onClickHandler: handleClick
  });
};
OnboardingButton.fragment = fragment9;
OnboardingButton.displayName = "OnboardingButton";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/common/onboarding-link.tsx
import React26 from "react";
import { gql as gql20 } from "@apollo/client";
var fragment10 = gql20(_templateObject19(), EGDSStandardLink.fragment);
var OnboardingLink = function (param) {
  var data = param.data,
    align = param.align;
  var link = data.link;
  return /* @__PURE__ */React26.createElement(EGDSStandardLink, {
    data: link,
    align: align
  });
};
OnboardingLink.fragment = fragment10;
OnboardingLink.displayName = "OnboardingLink";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/dismiss-button-position.tsx
import React27 from "react";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { ViewLarge, Viewport as Viewport5, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
var DismissButtonPosition = function (param) {
  var children = param.children;
  return /* @__PURE__ */React27.createElement(Viewport5, null, /* @__PURE__ */React27.createElement(ViewSmall4, null, /* @__PURE__ */React27.createElement(EGDSLayoutPosition, {
    position: {
      top: "two",
      left: "two"
    },
    type: "absolute"
  }, children)), /* @__PURE__ */React27.createElement(ViewLarge, null, /* @__PURE__ */React27.createElement(EGDSLayoutPosition, {
    position: {
      top: "six",
      left: "six"
    },
    type: "absolute"
  }, children)));
};
DismissButtonPosition.displayName = "DismissButtonPosition";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/hero-image.tsx
import React29 from "react";
import { gql as gql21 } from "@apollo/client";
import { EGDSImage as EGDSImage2 } from "@egds/react-core/images";
import { EGDSLayoutPosition as EGDSLayoutPosition2 } from "@egds/react-core/layout-position";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/hero-image-figure.tsx
import React28 from "react";
import { EGDSFigure, EGDSFigureAspectRatioType } from "@egds/react-core/images";
import { ViewLarge as ViewLarge2, Viewport as Viewport6, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
var HeroImageFigure = function (param) {
  var children = param.children;
  return /* @__PURE__ */React28.createElement("div", null, /* @__PURE__ */React28.createElement(Viewport6, null, /* @__PURE__ */React28.createElement(ViewSmall5, null, /* @__PURE__ */React28.createElement(EGDSFigure, {
    imageFit: "cover",
    ratio: EGDSFigureAspectRatioType.R1_1
  }, children)), /* @__PURE__ */React28.createElement(ViewLarge2, null, /* @__PURE__ */React28.createElement(EGDSFigure, {
    imageFit: "cover",
    ratio: EGDSFigureAspectRatioType.R4_1
  }, children))));
};
HeroImageFigure.displayName = "HeroImageFigure";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/hero-image.tsx
var fragment11 = gql21(_templateObject20());
var HeroImage = function (param) {
  var data = param.data,
    children = param.children;
  var url = data.url,
    description = data.description;
  return /* @__PURE__ */React29.createElement(HeroImageFigure, null, /* @__PURE__ */React29.createElement(EGDSImage2, {
    src: url,
    alt: description
  }), children && /* @__PURE__ */React29.createElement(EGDSLayoutPosition2, {
    type: "absolute",
    position: {
      left: "zero",
      bottom: "zero",
      right: "zero"
    }
  }, children));
};
HeroImage.fragment = fragment11;
HeroImage.displayName = "HeroImage";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/welcome-screen/welcome-screen.tsx
var fragment12 = gql22(_templateObject21(), OnboardingLink.fragment, BrandAssets.fragment, HeroImage.fragment, OnboardingButton.fragment);
var WelcomeScreen = function (param) {
  var data = param.data;
  var heroImage = data.heroImage,
    brandAssets = data.brandAssets,
    title = data.title,
    subTitles = data.subTitles,
    learnMoreLink = data.learnMoreLink,
    primaryButton = data.primaryButton,
    consentText = data.consentText,
    termsAndConditionsLink = data.termsAndConditionsLink,
    privacyLink = data.privacyLink,
    dismissButton = data.dismissButton,
    onLoadOperation = data.onLoadOperation,
    ariaLabel = data.ariaLabel;
  var impressionClickstreamEventData = {
    event: {
      event_version: "1.0.0",
      event_name: "onekey_welcome_onboarding.viewed",
      event_type: "Page View"
    },
    experience: {
      page_name: "OKOnboarding",
      page_name_detailed: "OKOnboardingWelcomeScreen"
    }
  };
  var isConsentSectionVisible = consentText || termsAndConditionsLink || privacyLink;
  var systemEvents = useLoggerEvents8(UNIVERSAL_ONBOARDING_LOGGER_EVENTS);
  var _useOnboardingDialogContext = useOnboardingDialogContext(),
    isDialogOpen = _useOnboardingDialogContext.isDialogOpen,
    closeDialog = _useOnboardingDialogContext.closeDialog;
  var proceedWithOnboardingFlow = useOnboardingUtils().proceedWithOnboardingFlow;
  var _useUniversalOnboardingOperation = _sliced_to_array(useUniversalOnboardingOperation(getUniversalOnboardingActionType(onLoadOperation)), 1),
    onboardingOperation2 = _useUniversalOnboardingOperation[0];
  var handleOperationSuccess = useCallback13(function () {
    systemEvents.ONE_KEY_UNIVERSAL_ONBOARDING_WELCOME_SCREEN_MUTATION_SUCCESS.log(stringifyEventPayload({
      message: "Welcome Screen mutation success"
    }));
  }, [systemEvents]);
  var handleOperationFailure = useCallback13(function (result) {
    systemEvents.ONE_KEY_UNIVERSAL_ONBOARDING_WELCOME_SCREEN_MUTATION_FAILURE.log(stringifyEventPayload({
      message: "Welcome Screen mutation failure. Onboarding Operation response: ".concat(JSON.stringify(result.data))
    }));
  }, [systemEvents]);
  var handleOperationError = useCallback13(function (error) {
    systemEvents.ONE_KEY_UNIVERSAL_ONBOARDING_WELCOME_SCREEN_MUTATION_ERROR.log(stringifyEventPayload({
      message: "Welcome Screen mutation error",
      error: error
    }));
  }, [systemEvents]);
  useEffect8(function () {
    if (onLoadOperation) {
      onboardingOperation2().then(function (result) {
        if (isOperationStatusSucceeded(result)) {
          handleOperationSuccess();
        } else {
          handleOperationFailure(result);
        }
      }).catch(function (error) {
        handleOperationError(error);
        navigateToErrorPage();
      });
    }
  }, []);
  return /* @__PURE__ */React30.createElement(EGDSSheet, {
    isVisible: isDialogOpen,
    triggerRef: null,
    type: "full",
    ariaLabel: ariaLabel
  }, /* @__PURE__ */React30.createElement(EGDSSheetContent, {
    padded: false
  }, /* @__PURE__ */React30.createElement(EgClickstreamImpressionTracker, {
    eventData: impressionClickstreamEventData
  }, /* @__PURE__ */React30.createElement("div", {
    "data-stid": "one-key-onboarding-welcome-screen"
  }, /* @__PURE__ */React30.createElement(HeroImage, {
    data: heroImage
  }, brandAssets && /* @__PURE__ */React30.createElement(EGDSSpacing, {
    padding: {
      inline: "six",
      block: "eight"
    }
  }, /* @__PURE__ */React30.createElement("div", null, /* @__PURE__ */React30.createElement(BrandAssets, {
    data: brandAssets
  })))), dismissButton && /* @__PURE__ */React30.createElement(DismissButtonPosition, null, /* @__PURE__ */React30.createElement(OnboardingButton, {
    data: dismissButton,
    size: EGDSButtonSize.MEDIUM,
    isNoTextAllowed: true,
    dataStid: "one-key-onboarding-welcome-screen-dismiss-button",
    onOperationSuccess: handleOperationSuccess,
    onOperationFailure: handleOperationFailure,
    onOperationError: handleOperationError,
    onNullActionClick: closeDialog
  })), /* @__PURE__ */React30.createElement("div", null, /* @__PURE__ */React30.createElement(EGDSSpacing, {
    padding: {
      inline: "six",
      block: "eight"
    }
  }, /* @__PURE__ */React30.createElement(EGDSLayoutFlex2, {
    justifyContent: "center",
    alignItems: "center"
  }, /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem2, {
    maxWidth: "120x"
  }, /* @__PURE__ */React30.createElement("div", null, /* @__PURE__ */React30.createElement(EGDSSpacing, {
    margin: {
      blockend: "eight"
    }
  }, /* @__PURE__ */React30.createElement(EGDSLayoutFlex2, {
    direction: "column",
    space: "four"
  }, /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React30.createElement(EGDSHeading, {
    tag: "h1",
    size: 4,
    align: "center"
  }, title)), /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React30.createElement("div", null, subTitles.map(function (subTitle, index) {
    return /* @__PURE__ */React30.createElement(EGDSText, {
      key: index,
      align: "center"
    }, subTitle);
  }))), /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React30.createElement(OnboardingLink, {
    data: learnMoreLink,
    align: "center"
  })))), /* @__PURE__ */React30.createElement(EGDSLayoutFlex2, {
    direction: "column",
    space: "six"
  }, isConsentSectionVisible && /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React30.createElement(EGDSLayoutFlex2, {
    direction: "column",
    space: "two"
  }, consentText && /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React30.createElement(EGDSText, {
    align: "center",
    size: 200
  }, consentText)), termsAndConditionsLink && /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React30.createElement(OnboardingLink, {
    data: termsAndConditionsLink,
    align: "center"
  })), privacyLink && /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React30.createElement(OnboardingLink, {
    data: privacyLink,
    align: "center"
  })))), /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React30.createElement(OnboardingButton, {
    data: primaryButton,
    size: EGDSButtonSize.LARGE,
    isFullWidth: true,
    dataStid: "one-key-onboarding-welcome-screen-primary-button",
    onOperationSuccess: handleOperationSuccess,
    onOperationFailure: handleOperationFailure,
    onOperationError: handleOperationError,
    onNullActionClick: proceedWithOnboardingFlow
  }))))))))))));
};
WelcomeScreen.fragment = fragment12;
WelcomeScreen.displayName = "WelcomeScreen";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/contextual-screen.tsx
import React40, { useCallback as useCallback16 } from "react";
import { gql as gql28 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize4 } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem, MinMax } from "@egds/react-core/layout-grid";
import { EGDSSheet as EGDSSheet3, EGDSSheetContent as EGDSSheetContent3 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3 } from "@egds/react-core/text";
import { EgClickstreamImpressionTracker as EgClickstreamImpressionTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useLoggerEvents as useLoggerEvents9 } from "@shared-ui/logger-context";
// ../internal/src/components/egds-loyalty-badge/egds-loyalty-badge.tsx
import React31 from "react";
import { gql as gql23 } from "@apollo/client";
import { UitkBadgeLoyalty } from "uitk-react-badge";
// ../internal/src/components/egds-loyalty-badge/__private/egds-loyalty-badge-sizes.ts
var loyaltyBadgeSizes = {
  small: "small",
  large: "large"
};
// ../internal/src/components/egds-loyalty-badge/__private/egds-loyalty-badge-theme.ts
var loyaltyBadgeThemes = {
  lowtier: "lowtier",
  midtier: "midtier",
  hightier: "hightier",
  vip: "vip",
  extrahightier: "extrahightier",
  "global-lowtier": "global-lowtier",
  "global-middletier": "global-middletier",
  "global-hightier": "global-hightier",
  "global-extrahightier": "global-extrahightier"
};
// ../internal/src/components/egds-loyalty-badge/egds-loyalty-badge.tsx
var fragment13 = gql23(_templateObject22());
var EGDSLoyaltyBadge = function (props) {
  var data = props.data;
  if (!data.badgeText) {
    return null;
  }
  var size = data.size,
    badgeTheme = data.badgeTheme,
    accessibility = data.accessibility,
    badgeText = data.badgeText;
  var selectedTheme = badgeTheme ? loyaltyBadgeThemes[badgeTheme] : void 0;
  var selectedSize = size ? loyaltyBadgeSizes[size] : void 0;
  return /* @__PURE__ */React31.createElement(UitkBadgeLoyalty, {
    a11yText: accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
    text: badgeText,
    size: selectedSize,
    theme: selectedTheme
  });
};
EGDSLoyaltyBadge.fragment = fragment13;
EGDSLoyaltyBadge.displayName = "EGDSLoyaltyBadge";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/common/brand-assets-spacing.tsx
import React32 from "react";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { ViewLarge as ViewLarge3, ViewMedium as ViewMedium5, Viewport as Viewport7, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
var BrandAssetsSpacing = function (param) {
  var children = param.children;
  return /* @__PURE__ */React32.createElement(Viewport7, null, /* @__PURE__ */React32.createElement(ViewSmall6, null, /* @__PURE__ */React32.createElement(EGDSSpacing2, {
    margin: {
      blockend: "eight"
    }
  }, /* @__PURE__ */React32.createElement("div", null, children))), /* @__PURE__ */React32.createElement(ViewMedium5, null, /* @__PURE__ */React32.createElement(EGDSSpacing2, {
    margin: {
      blockend: "sixteen"
    }
  }, /* @__PURE__ */React32.createElement("div", null, children))), /* @__PURE__ */React32.createElement(ViewLarge3, null, /* @__PURE__ */React32.createElement(EGDSSpacing2, {
    margin: {
      blockend: "eight"
    }
  }, /* @__PURE__ */React32.createElement("div", null, children))));
};
BrandAssetsSpacing.displayName = "BrandAssetsSpacing";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/balance-section.tsx
import React33 from "react";
import { gql as gql24 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex3 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
var fragment14 = gql24(_templateObject23());
var BalanceSection = function (param) {
  var data = param.data;
  var title = data.title,
    balance = data.balance,
    subTitles = data.subTitles;
  return /* @__PURE__ */React33.createElement(EGDSLayoutFlex3, {
    direction: "column",
    space: "four"
  }, /* @__PURE__ */React33.createElement(EGDSText2, {
    size: 400,
    align: "center"
  }, title), /* @__PURE__ */React33.createElement(EGDSText2, {
    size: 700,
    align: "center",
    weight: "medium"
  }, balance), /* @__PURE__ */React33.createElement("div", null, subTitles.map(function (subTitle, index) {
    return /* @__PURE__ */React33.createElement(EGDSText2, {
      key: index,
      align: "center"
    }, subTitle);
  })));
};
BalanceSection.fragment = fragment14;
BalanceSection.displayName = "BalanceSection";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/benefit.tsx
import React34 from "react";
import { gql as gql25 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex4 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
var fragment15 = gql25(_templateObject24(), EGDSIcon2.fragment);
var Benefit = function (param) {
  var data = param.data;
  var icon = data.icon,
    description = data.description;
  return /* @__PURE__ */React34.createElement(EGDSLayoutFlex4, {
    space: "two"
  }, /* @__PURE__ */React34.createElement(EGDSIcon2, {
    data: icon
  }), /* @__PURE__ */React34.createElement(EGDSText3, null, description));
};
Benefit.fragment = fragment15;
Benefit.displayName = "Benefit";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/benefits.tsx
import React35 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
var Benefits = function (param) {
  var benefits = param.benefits;
  return /* @__PURE__ */React35.createElement(EGDSLayoutFlex5, {
    direction: "column",
    space: "four"
  }, benefits.map(function (benefit, index) {
    return /* @__PURE__ */React35.createElement(EGDSLayoutFlexItem3, {
      key: index
    }, /* @__PURE__ */React35.createElement(Benefit, {
      data: benefit
    }));
  }));
};
Benefits.displayName = "Benefits";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/card-with-spacing.tsx
import React36 from "react";
import { EGDSCard as EGDSCard2 } from "@egds/react-core/cards";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { ViewMedium as ViewMedium6, Viewport as Viewport8, ViewSmall as ViewSmall7 } from "@shared-ui/viewport-context";
var CardWithSpacing = function (param) {
  var children = param.children;
  return /* @__PURE__ */React36.createElement(Viewport8, null, /* @__PURE__ */React36.createElement(ViewSmall7, null, /* @__PURE__ */React36.createElement(EGDSSpacing3, {
    margin: {
      blockend: "eight"
    }
  }, /* @__PURE__ */React36.createElement("div", null, /* @__PURE__ */React36.createElement(EGDSCard2, {
    border: true
  }, /* @__PURE__ */React36.createElement(EGDSSpacing3, {
    padding: "eight"
  }, /* @__PURE__ */React36.createElement("div", null, children)))))), /* @__PURE__ */React36.createElement(ViewMedium6, null, /* @__PURE__ */React36.createElement(EGDSSpacing3, {
    padding: {
      inline: "six"
    },
    margin: {
      blockend: "eight"
    }
  }, /* @__PURE__ */React36.createElement("div", null, /* @__PURE__ */React36.createElement(EGDSCard2, {
    border: true
  }, /* @__PURE__ */React36.createElement(EGDSSpacing3, {
    padding: "twelve"
  }, /* @__PURE__ */React36.createElement("div", null, children)))))));
};
CardWithSpacing.displayName = "CardWithSpacing";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/content-spacing.tsx
import React37 from "react";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { ViewLarge as ViewLarge4, ViewMedium as ViewMedium7, Viewport as Viewport9, ViewSmall as ViewSmall8 } from "@shared-ui/viewport-context";
var ContentSpacing = function (param) {
  var children = param.children;
  return /* @__PURE__ */React37.createElement(Viewport9, null, /* @__PURE__ */React37.createElement(ViewSmall8, null, /* @__PURE__ */React37.createElement(EGDSSpacing4, {
    padding: "six"
  }, children)), /* @__PURE__ */React37.createElement(ViewMedium7, null, /* @__PURE__ */React37.createElement(EGDSSpacing4, {
    padding: "sixteen"
  }, children)), /* @__PURE__ */React37.createElement(ViewLarge4, null, /* @__PURE__ */React37.createElement(EGDSSpacing4, {
    padding: "twelve"
  }, children)));
};
ContentSpacing.displayName = "ContentSpacing";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/info-section.tsx
import React39, { useCallback as useCallback15 } from "react";
import { gql as gql27 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize3 } from "@egds/react-core/button";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/info-dialog.tsx
import React38, { useCallback as useCallback14 } from "react";
import { gql as gql26 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize2 } from "@egds/react-core/button";
import { EGDSSheet as EGDSSheet2, EGDSSheetContent as EGDSSheetContent2, EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSText as EGDSText4 } from "@egds/react-core/text";
import { EgClickstreamImpressionTracker as EgClickstreamImpressionTracker2 } from "@shared-ui/clickstream-analytics-context";
var fragment16 = gql26(_templateObject25(), OnboardingButton.fragment);
var InfoDialog = function (param) {
  var data = param.data,
    isDialogOpen = param.isDialogOpen,
    DialogComponent = param.DialogComponent,
    onActionClick = param.onActionClick;
  var impressionClickstreamEventData = {
    event: {
      event_version: "1.0.0",
      event_name: "onekey_context_onboarding_onekey_cash.presented",
      event_type: "Impression"
    },
    experience: {
      page_name: "OKOnboarding",
      page_name_detailed: "OKOnboardingContextualScreen"
    }
  };
  var heading = data.heading,
    description = data.description,
    primaryButton = data.primaryButton,
    ariaLabel = data.ariaLabel;
  var handleActionClick = useCallback14(function () {
    onActionClick();
  }, [onActionClick]);
  return /* @__PURE__ */React38.createElement(EGDSSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React38.createElement(DialogComponent, null, /* @__PURE__ */React38.createElement(EGDSSheet2, {
    isVisible: isDialogOpen,
    triggerRef: null,
    type: "centered",
    centeredSheetSize: "small",
    ariaLabel: ariaLabel
  }, /* @__PURE__ */React38.createElement(EgClickstreamImpressionTracker2, {
    eventData: impressionClickstreamEventData
  }, /* @__PURE__ */React38.createElement(EGDSSheetContent2, null, /* @__PURE__ */React38.createElement(EGDSSpacing5, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React38.createElement(EGDSHeading2, {
    tag: "h2",
    size: 5
  }, heading)), /* @__PURE__ */React38.createElement(EGDSSpacing5, {
    margin: {
      blockend: "four"
    }
  }, /* @__PURE__ */React38.createElement(EGDSText4, null, description)), /* @__PURE__ */React38.createElement(OnboardingButton, {
    data: primaryButton,
    size: EGDSButtonSize2.MEDIUM,
    isFullWidth: true,
    onNullActionClick: handleActionClick
  }))))));
};
InfoDialog.fragment = fragment16;
InfoDialog.displayName = "InfoDialog";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/info-section.tsx
var fragment17 = gql27(_templateObject26(), OnboardingButton.fragment, InfoDialog.fragment);
var InfoSection = function (param) {
  var data = param.data;
  var infoButton = data.infoButton,
    dialog = data.dialog;
  var _useDialog2 = _sliced_to_array(useDialog2("one-key-onboarding-info-section-dialog", "infoPwaDialog", true), 3),
    isDialogOpen = _useDialog2[0],
    dialogActions = _useDialog2[1],
    DialogComponent = _useDialog2[2];
  var handleInfoButtonClick = useCallback15(function () {
    dialogActions.openDialog();
  }, [dialogActions]);
  var handleDialogActionClick = useCallback15(function () {
    dialogActions.closeDialog();
  }, [dialogActions]);
  return /* @__PURE__ */React39.createElement(React39.Fragment, null, /* @__PURE__ */React39.createElement(OnboardingButton, {
    data: infoButton,
    size: EGDSButtonSize3.SMALL,
    isNoTextAllowed: true,
    onNullActionClick: handleInfoButtonClick
  }), /* @__PURE__ */React39.createElement(InfoDialog, {
    data: dialog,
    isDialogOpen: isDialogOpen,
    DialogComponent: DialogComponent,
    onActionClick: handleDialogActionClick
  }));
};
InfoSection.fragment = fragment17;
InfoSection.displayName = "InfoSection";
// src/components/one-key-onboarding/one-key-universal-onboarding/onboarding-screens/contextual-screen/contextual-screen.tsx
var fragment18 = gql28(_templateObject27(), OnboardingLink.fragment, EGDSLoyaltyBadge.fragment, BrandAssets.fragment, InfoSection.fragment, Benefit.fragment, BalanceSection.fragment, OnboardingButton.fragment);
var ContextualScreen = function (param) {
  var data = param.data;
  var impressionClickstreamEventData = {
    event: {
      event_version: "1.0.0",
      event_name: "onekey_context_onboarding.viewed",
      event_type: "Page View"
    },
    experience: {
      page_name: "OKOnboarding",
      page_name_detailed: "OKOnboardingContextualScreen"
    }
  };
  var brandAssets = data.brandAssets,
    oneKeyCashInfoSection = data.oneKeyCashInfoSection,
    tierBadge = data.tierBadge,
    title = data.title,
    benefits = data.benefits,
    balanceSection = data.balanceSection,
    primaryButton = data.primaryButton,
    primaryLink = data.primaryLink,
    ariaLabel = data.ariaLabel;
  var systemEvents = useLoggerEvents9(UNIVERSAL_ONBOARDING_LOGGER_EVENTS);
  var isDialogOpen = useOnboardingDialogContext().isDialogOpen;
  var proceedWithOnboardingFlow = useOnboardingUtils().proceedWithOnboardingFlow;
  var handleOperationSuccess = useCallback16(function () {
    systemEvents.ONE_KEY_UNIVERSAL_ONBOARDING_CONTEXTUAL_SCREEN_MUTATION_SUCCESS.log(stringifyEventPayload({
      message: "Contextual Screen mutation success"
    }));
  }, [systemEvents]);
  var handleOperationFailure = useCallback16(function (result) {
    systemEvents.ONE_KEY_UNIVERSAL_ONBOARDING_CONTEXTUAL_SCREEN_MUTATION_FAILURE.log(stringifyEventPayload({
      message: "Contextual Screen mutation failure. Onboarding Operation response: ".concat(JSON.stringify(result.data))
    }));
  }, [systemEvents]);
  var handleOperationError = useCallback16(function (error) {
    systemEvents.ONE_KEY_UNIVERSAL_ONBOARDING_CONTEXTUAL_SCREEN_MUTATION_ERROR.log(stringifyEventPayload({
      message: "Contextual Screen mutation error",
      error: error
    }));
  }, [systemEvents]);
  return /* @__PURE__ */React40.createElement(EGDSSheet3, {
    isVisible: isDialogOpen,
    triggerRef: null,
    type: "full",
    ariaLabel: ariaLabel
  }, /* @__PURE__ */React40.createElement(EGDSSheetContent3, {
    padded: false
  }, /* @__PURE__ */React40.createElement(EgClickstreamImpressionTracker3, {
    eventData: impressionClickstreamEventData
  }, /* @__PURE__ */React40.createElement(ContentSpacing, null, /* @__PURE__ */React40.createElement(EGDSLayoutGrid, {
    columns: [MinMax("0x", "120x")],
    justifyContent: "center",
    "data-stid": "one-key-onboarding-contextual-screen"
  }, /* @__PURE__ */React40.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React40.createElement("div", null, brandAssets && /* @__PURE__ */React40.createElement(BrandAssetsSpacing, null, /* @__PURE__ */React40.createElement(BrandAssets, {
    data: brandAssets
  })), /* @__PURE__ */React40.createElement(CardWithSpacing, null, /* @__PURE__ */React40.createElement(EGDSLayoutFlex6, {
    justifyContent: "center"
  }, /* @__PURE__ */React40.createElement(EGDSLayoutFlexItem4, {
    maxWidth: "70x"
  }, /* @__PURE__ */React40.createElement("div", null, /* @__PURE__ */React40.createElement(EGDSLayoutFlex6, {
    direction: "column",
    justifyContent: "center",
    alignItems: "center",
    space: "six"
  }, /* @__PURE__ */React40.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React40.createElement(EGDSLoyaltyBadge, {
    data: tierBadge
  })), /* @__PURE__ */React40.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React40.createElement(EGDSHeading3, {
    tag: "h1",
    size: 4,
    align: "center"
  }, title)), benefits && /* @__PURE__ */React40.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React40.createElement(Benefits, {
    benefits: benefits
  })), balanceSection && /* @__PURE__ */React40.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React40.createElement(BalanceSection, {
    data: balanceSection
  })), oneKeyCashInfoSection && /* @__PURE__ */React40.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React40.createElement(InfoSection, {
    data: oneKeyCashInfoSection
  }))))))), /* @__PURE__ */React40.createElement(OnboardingButton, {
    data: primaryButton,
    isFullWidth: true,
    size: EGDSButtonSize4.LARGE,
    dataStid: "one-key-onboarding-contextual-screen-primary-button",
    onOperationSuccess: handleOperationSuccess,
    onOperationFailure: handleOperationFailure,
    onOperationError: handleOperationError,
    onNullActionClick: proceedWithOnboardingFlow
  }), primaryLink && /* @__PURE__ */React40.createElement(EGDSSpacing6, {
    margin: {
      blockstart: "eight"
    }
  }, /* @__PURE__ */React40.createElement("div", null, /* @__PURE__ */React40.createElement(OnboardingLink, {
    data: primaryLink,
    align: "center"
  }))))))))));
};
ContextualScreen.fragment = fragment18;
ContextualScreen.displayName = "ContextualScreen";
// src/components/one-key-onboarding/onboarding-screen.tsx
var OnboardingScreen = function () {
  var currentScreen = useOnboardingScreensContext().currentScreen;
  switch (currentScreen === null || currentScreen === void 0 ? void 0 : currentScreen.__typename) {
    case "OneKeyOnboardingGettingStarted":
      {
        return /* @__PURE__ */React41.createElement(GettingStarted, {
          data: currentScreen
        });
      }
    case "OneKeyOnboardingTermsAndConditions":
      {
        return /* @__PURE__ */React41.createElement(TermsAndConditions, {
          data: currentScreen
        });
      }
    case "OneKeyOnboardingInterstitialLoading":
      {
        return /* @__PURE__ */React41.createElement(InterstitialLoading, {
          data: currentScreen
        });
      }
    case "OneKeyOnboardingAccountMerge":
      {
        return /* @__PURE__ */React41.createElement(AccountMerge, {
          data: currentScreen
        });
      }
    case "OneKeyContextualOnboarding":
      {
        return /* @__PURE__ */React41.createElement(ContextualOnboarding, {
          data: currentScreen
        });
      }
    case "OneKeyUniversalOnboardingWelcomeScreen":
      {
        return /* @__PURE__ */React41.createElement(WelcomeScreen, {
          data: currentScreen
        });
      }
    case "OneKeyUniversalOnboardingContextualScreen":
      {
        return /* @__PURE__ */React41.createElement(ContextualScreen, {
          data: currentScreen
        });
      }
    default:
      {
        return null;
      }
  }
};
OnboardingScreen.displayName = "OnboardingScreen";
// src/components/one-key-onboarding/one-key-onboarding.tsx
var __Query = gql29(_templateObject28(), GettingStarted.fragment, TermsAndConditions.fragment, InterstitialLoading.fragment, AccountMerge.fragment, ContextualOnboarding.fragment);
var OneKeyOnboarding = function (param) {
  var inputs = param.inputs,
    shouldNavigateOnQueryError = param.shouldNavigateOnQueryError;
  var _useOnboardingDialogContext = useOnboardingDialogContext(),
    isDialogOpen = _useOnboardingDialogContext.isDialogOpen,
    openDialog = _useOnboardingDialogContext.openDialog,
    DialogComponent = _useOnboardingDialogContext.DialogComponent;
  var _useState6 = _sliced_to_array(useState6(false), 2),
    isDialogTriggered = _useState6[0],
    setIsDialogTriggered = _useState6[1];
  var context = useBexApi4().context;
  var systemEvents = useLoggerEvents10(LOGGER_EVENTS);
  var setScreens = useOnboardingScreensContext().setScreens;
  var variables = {
    additionalContext: inputs.additionalContext || null,
    context: context
  };
  var _useQuery = useQuery(__Query, {
      variables: variables,
      ssr: false
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  useEffect9(function () {
    if (data) {
      setScreens(data.oneKeyOnboarding);
    }
  }, [data]);
  useEffect9(function () {
    var _data_oneKeyOnboarding;
    if (data && (data === null || data === void 0 ? void 0 : (_data_oneKeyOnboarding = data.oneKeyOnboarding) === null || _data_oneKeyOnboarding === void 0 ? void 0 : _data_oneKeyOnboarding.length) !== 0 && !isDialogTriggered) {
      openDialog();
      setIsDialogTriggered(true);
    }
  }, [data, openDialog, isDialogTriggered, setIsDialogTriggered]);
  if (error) {
    systemEvents.ONE_KEY_ONBOARDING_QUERY_ERROR.log(stringifyEventPayload({
      message: "OneKeyOnboardingQuery error",
      error: error
    }));
    if (shouldNavigateOnQueryError) {
      navigateToErrorPage();
    }
  }
  if (loading || error || !data) {
    return null;
  }
  var oneKeyOnboarding = data.oneKeyOnboarding;
  var additionalContext = inputs.additionalContext;
  if (oneKeyOnboarding.length === 0) {
    if (additionalContext === null || additionalContext === void 0 ? void 0 : additionalContext.originUrl) {
      window.location.assign(toRelativeURL(additionalContext.originUrl));
    }
    return null;
  }
  return /* @__PURE__ */React42.createElement(AdditionalContextProvider, {
    additionalContext: additionalContext
  }, /* @__PURE__ */React42.createElement(UitkSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React42.createElement(DialogComponent, null, /* @__PURE__ */React42.createElement(OnboardingScreen, null))));
};
OneKeyOnboarding.displayName = "OneKeyOnboarding";
// src/components/one-key-onboarding/one-key-universal-onboarding/one-key-universal-onboarding.tsx
import React43, { useEffect as useEffect10, useState as useState7 } from "react";
import { gql as gql30, useQuery as useQuery2 } from "@apollo/client";
import { EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
import { useLoggerEvents as useLoggerEvents11 } from "@shared-ui/logger-context";
var __Query2 = gql30(_templateObject29(), WelcomeScreen.fragment, ContextualScreen.fragment);
var OneKeyUniversalOnboarding = function (param) {
  var inputs = param.inputs,
    isRedirectionEnabled = param.isRedirectionEnabled;
  var _useOnboardingDialogContext = useOnboardingDialogContext(),
    isDialogOpen = _useOnboardingDialogContext.isDialogOpen,
    openDialog = _useOnboardingDialogContext.openDialog,
    DialogComponent = _useOnboardingDialogContext.DialogComponent;
  var _useState7 = _sliced_to_array(useState7(false), 2),
    isDialogTriggered = _useState7[0],
    setIsDialogTriggered = _useState7[1];
  var context = useBexApi5().context;
  var systemEvents = useLoggerEvents11(UNIVERSAL_ONBOARDING_LOGGER_EVENTS);
  var setScreens = useOnboardingScreensContext().setScreens;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery2 = useQuery2(__Query2, {
      variables: variables,
      ssr: false
    }),
    data = _useQuery2.data,
    error = _useQuery2.error,
    loading = _useQuery2.loading;
  useEffect10(function () {
    if (data) {
      setScreens(data.oneKeyUniversalOnboarding);
    }
  }, [data]);
  useEffect10(function () {
    if ((data === null || data === void 0 ? void 0 : data.oneKeyUniversalOnboarding) && data.oneKeyUniversalOnboarding.length > 0 && !isDialogTriggered) {
      openDialog();
      setIsDialogTriggered(true);
    }
  }, [data === null || data === void 0 ? void 0 : data.oneKeyUniversalOnboarding, openDialog, isDialogTriggered]);
  useEffect10(function () {
    if ((data === null || data === void 0 ? void 0 : data.oneKeyUniversalOnboarding.length) === 0 && isRedirectionEnabled) {
      navigateToRelativeUrlOrFallbackUrl(inputs.originUrl);
    }
  }, [data === null || data === void 0 ? void 0 : data.oneKeyUniversalOnboarding, inputs.originUrl, isRedirectionEnabled]);
  useEffect10(function () {
    if (error) {
      systemEvents.ONE_KEY_UNIVERSAL_ONBOARDING_QUERY_ERROR.log(stringifyEventPayload({
        message: "OneKeyUniversalOnboardingQuery error",
        error: error
      }));
      if (isRedirectionEnabled) {
        navigateToErrorPage();
      }
    }
  }, [error, isRedirectionEnabled, systemEvents]);
  if (loading || error || !data) {
    return null;
  }
  if (data.oneKeyUniversalOnboarding.length === 0) {
    return null;
  }
  return /* @__PURE__ */React43.createElement(EGDSSheetTransition2, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React43.createElement(DialogComponent, null, /* @__PURE__ */React43.createElement(OnboardingScreen, null)));
};
OneKeyUniversalOnboarding.displayName = "OneKeyUniversalOnboarding";
// src/components/one-key-onboarding/one-key-onboarding-wrapper.tsx
var OneKeyOnboardingWrapper = function (param) {
  var additionalContext = param.additionalContext,
    _param_isRedirectionEnabled = param.isRedirectionEnabled,
    isRedirectionEnabled = _param_isRedirectionEnabled === void 0 ? false : _param_isRedirectionEnabled;
  var systemEvents = useLoggerEvents12(LOGGER_EVENTS);
  var _useExperiment = useExperiment("one_key_onboarding_ui_enabled"),
    oneKeyOnboardingMVPExposure = _useExperiment.exposure;
  var _useExperiment1 = useExperiment("Onboarding_v2_Web"),
    onboardingV2Exposure = _useExperiment1.exposure;
  var _useExperiment2 = useExperiment("Onboarding_v2_OneKey_Web"),
    oneKeyOnboardingV2Exposure = _useExperiment2.exposure;
  var isMVPFlowEnabled = oneKeyOnboardingMVPExposure.bucket === 1;
  var isV2FlowEnabled = onboardingV2Exposure.bucket === 1 && oneKeyOnboardingV2Exposure.bucket === 1;
  var isOnboardingDisabled = !isMVPFlowEnabled && !isV2FlowEnabled;
  useEffect11(function () {
    systemEvents.ONE_KEY_ONBOARDING_TNL_EXPOSURE.log(stringifyEventPayload({
      message: "OneKey Onboarding TnL exposure. one_key_onboarding_ui_enabled: ".concat(JSON.stringify(oneKeyOnboardingMVPExposure), ". Onboarding_v2_Web: ").concat(JSON.stringify(onboardingV2Exposure), ". Onboarding_v2_OneKey_Web: ").concat(JSON.stringify(oneKeyOnboardingV2Exposure))
    }));
  }, [systemEvents, oneKeyOnboardingMVPExposure, onboardingV2Exposure, oneKeyOnboardingV2Exposure]);
  useEffect11(function () {
    if (isOnboardingDisabled && isRedirectionEnabled) {
      navigateToRelativeUrlOrFallbackUrl(additionalContext === null || additionalContext === void 0 ? void 0 : additionalContext.originUrl);
    }
  }, []);
  if (isOnboardingDisabled) {
    return null;
  }
  return /* @__PURE__ */React44.createElement(OnboardingDialogContextProvider, null, /* @__PURE__ */React44.createElement(OnboardingScreensProvider, null, /* @__PURE__ */React44.createElement(MutationProgressProvider, null, isV2FlowEnabled ? /* @__PURE__ */React44.createElement(OneKeyUniversalOnboarding, {
    inputs: {
      originUrl: additionalContext === null || additionalContext === void 0 ? void 0 : additionalContext.originUrl
    },
    isRedirectionEnabled: isRedirectionEnabled
  }) : /* @__PURE__ */React44.createElement(OneKeyOnboarding, {
    inputs: {
      additionalContext: additionalContext
    },
    shouldNavigateOnQueryError: isRedirectionEnabled
  }))));
};
OneKeyOnboardingWrapper.displayName = "sharedui-OneKeyOnboarding";
export { OneKeyOnboardingWrapper, toRelativeURL }; /* istanbul ignore next -- @preserve */